var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _rect, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _rect2, _rect3, _rect4, _path98, _rect5, _rect6, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _rect7, _rect8, _rect9, _rect10, _rect11, _path111, _g, _path112, _path113, _rect12, _rect13, _rect14, _rect15, _rect16, _path114, _g2, _path115, _path116, _rect17, _rect18, _rect19, _rect20, _rect21, _path117, _g3, _path118, _path119, _rect22, _rect23, _rect24, _rect25, _rect26, _path120, _g4, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _rect27, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _rect28, _rect29, _rect30, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _rect31, _rect32, _rect33, _rect34, _rect35, _path234, _g5, _path235, _path236, _rect36, _rect37, _rect38, _rect39, _rect40, _path237, _g6, _path238, _path239, _rect41, _rect42, _rect43, _rect44, _rect45, _path240, _g7, _path241, _path242, _rect46, _rect47, _rect48, _rect49, _rect50, _path243, _g8, _path244, _path245, _path246, _path247, _path248, _g9, _path249, _path250, _path251, _path252, _g10, _circle, _g11, _mask, _path253, _path254, _path255, _path256, _g12, _ellipse, _mask2, _path257, _g13, _path258, _path259, _path260, _path261, _rect51, _rect52, _path262, _path263, _path264, _path265, _g14, _path266, _path267, _path268, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeskImage2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 587,
    height: 583,
    viewBox: "0 0 587 583",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.085 581.547C143.792 579.517 136.994 574.639 133.427 570.311C127.041 562.564 125.799 552.593 129.482 538.667C130.817 533.621 131.676 527.252 131.732 522C131.732 522 132.506 516.749 131.822 513.5C130.854 508.905 130.891 508.618 125.857 503.059C120.823 497.5 117.567 484.774 122.305 470.551C125.677 460.43 128.287 456.421 133.671 453.093C137.72 450.591 171.478 438.91 176.509 438.271C179.819 437.85 180.723 438.295 185.354 442.626C193.429 450.18 194.837 453.608 194.744 465.5C194.68 473.817 194.025 477.856 190.851 489.5C190.851 489.5 188.066 497.928 187.035 503.5C185.115 513.872 186.281 530.5 186.281 530.5C185.522 557.65 184.772 563.405 181.067 570.5C179.093 574.28 174.844 578.253 170.322 580.547C165.692 582.896 154.032 583.445 149.085 581.547Z",
    fill: "#311739"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M152 509.534V522L165 520.3L165.5 512.5L167 510.5C167 509.367 165.8 509.307 165 508.4C164.2 507.494 161.667 505.756 160.5 505L152 509.534Z",
    fill: "url(#paint0_linear_4903_18626)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.605 580.746C146.405 579.918 143.529 578.414 142.214 577.403C139.857 575.593 139.845 575.498 141.395 570.949C145.018 560.316 154.59 549.614 165.345 544.173C170.386 541.623 181.279 538.345 184.855 538.303C187.747 538.269 185.133 561.353 181.406 568.751C179.178 573.174 175.166 577.182 170.605 579.538C165.402 582.225 154.175 582.842 148.605 580.746Z",
    fill: "url(#paint1_linear_4903_18626)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.348 563.65C157.616 562.468 154.273 558.175 150.92 554.11L144.822 546.72L144.866 538.055C144.925 526.574 146.553 523.71 155.672 519.05L162.822 516L165.897 517.47C167.807 518.499 170.371 520.951 171.596 522.92C173.543 526.051 175.814 527.818 175.759 537C175.69 548.613 175.073 550.443 168.115 559.658C163.467 565.814 160.116 566.508 158.348 563.65ZM137.333 544.513C135.924 542.816 136.528 539.428 138.76 536.5C140.075 534.774 140.421 534.705 141.288 536C142.593 537.95 142.592 541.627 141.287 544.066C140.045 546.386 138.987 546.506 137.333 544.513Z",
    fill: "url(#paint2_linear_4903_18626)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M179.822 536.5C182.054 539.428 182.658 542.816 181.249 544.513C179.595 546.506 179.537 546.386 178.295 544.066C176.99 541.627 176.989 537.95 178.294 536C179.161 534.705 178.507 534.774 179.822 536.5Z",
    fill: "url(#paint3_linear_4903_18626)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M149.145 509.176C149.988 510.838 151.102 512.73 151.619 513.38C151.896 513.728 151.914 513.931 152.013 513.985C152.171 514.072 152.537 513.779 154.5 513.085C156.801 512.273 165.157 512.766 166.429 513.085C167.23 513.286 167.323 513.014 167.527 512.415C167.75 511.762 168.105 510.722 169.651 509.483C171.906 507.676 178.064 503.948 183.338 501.198C191.134 497.132 193.325 495.475 195.065 492.329C197.222 488.43 197.566 487.044 201.807 465.197C203.308 457.469 205.403 450.456 207.693 445.5C208.699 443.323 209.462 441.413 209.911 440H193.78C192.243 443.57 189.828 450.115 188.743 454.788C187.224 461.338 185.666 466.698 185.283 466.698C182.656 466.698 184.349 450.613 187.858 442.212C188.209 441.372 188.471 440.64 188.627 440H149.079C148.628 441.543 147.947 445.862 147.423 450.67C146.793 456.43 145.908 461.806 145.454 462.616C144.14 464.965 143.233 451.944 144.278 445.73C144.73 443.047 144.987 441.217 144.853 440H130.96C130.349 441.655 129.075 447.354 127.901 453.788C125.841 465.077 125.613 468.147 126.467 473.198C128.416 484.749 129.694 489.242 132.605 494.791C135.168 499.676 136.304 500.748 141.576 503.269C145.7 505.24 148.099 507.111 149.145 509.176Z",
    fill: "#E5E1F4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M180.684 502.622C176.143 505.123 171.535 507.974 169.651 509.483C168.105 510.722 167.75 511.762 167.527 512.415C167.323 513.014 167.23 513.286 166.429 513.085C165.157 512.766 156.801 512.273 154.5 513.085C153.562 513.417 152.988 513.657 152.628 513.808C152.234 513.972 152.096 514.031 152.013 513.985C151.914 513.931 151.896 513.728 151.619 513.38C151.103 512.73 149.988 510.838 149.146 509.176C148.099 507.111 145.7 505.24 141.576 503.269C137.488 501.315 135.887 500.231 134.18 497.566C135.501 491.354 144.317 489.262 159.785 491.524C174.087 493.615 181.219 497.45 180.684 502.622Z",
    fill: "url(#paint4_linear_4903_18626)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.794 455.73C146.293 459.293 145.77 462.054 145.455 462.616C145.335 462.832 145.217 462.918 145.104 462.892C143.8 470.266 143.31 478.847 143.501 484.295L142.407 490.913L145.561 484.294C147.295 480.655 149.242 476.923 149.889 476.002C152.69 472.01 161.581 468.398 171.902 467.062C177.734 466.305 182.734 465.416 183.012 465.084C183.995 463.915 181.799 462.116 176.487 459.74C169.643 456.679 164.539 449.726 161.871 440H149.08C148.629 441.543 147.948 445.862 147.424 450.671C147.255 452.221 147.067 453.743 146.873 455.156C146.867 455.285 146.86 455.418 146.85 455.555C146.831 455.613 146.812 455.671 146.794 455.73Z",
    fill: "url(#paint5_linear_4903_18626)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.907 512.695C161.385 512.674 160.848 512.659 160.31 512.65C160.895 509.393 162.31 504.787 164.597 497.344C165.107 495.681 165.662 493.876 166.26 491.913L171.874 473.5L170.26 460.948C169.147 452.288 168.185 443.628 168.039 440H168.789C169.295 442.448 170.303 450.207 171.135 458.149L172.775 473.798L170.275 482.149C164.419 501.715 162.417 508.621 161.907 512.695Z",
    fill: "url(#paint6_linear_4903_18626)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.382 440H130.96C130.349 441.655 129.075 447.354 127.901 453.788C125.841 465.077 125.613 468.147 126.467 473.198C128.416 484.749 129.694 489.242 132.605 494.791C134.407 498.227 135.504 499.777 137.83 501.271C137.873 501.209 137.916 501.144 137.958 501.075C138.304 500.515 137.6 493.653 136.393 485.825C133.906 469.693 134.135 455.936 137.063 445.593C137.576 443.781 138.05 441.743 138.382 440Z",
    fill: "url(#paint7_linear_4903_18626)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.005 440H193.78C192.243 443.57 189.828 450.115 188.743 454.788C187.223 461.338 185.666 466.698 185.283 466.698C185.252 466.698 185.221 466.696 185.191 466.692C184.593 471.401 184.803 475.494 185.652 480.377C186.696 486.387 187.376 487.628 188.809 486.142C189.212 485.724 190.634 479.497 191.969 472.302C194.399 459.211 197.814 448.234 202.005 440Z",
    fill: "url(#paint8_linear_4903_18626)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M301.529 515.996C299.593 516.498 191.195 517 191.195 517C191.195 517 187.807 517 186.839 514.49C185.871 511.979 182 455.746 182 453.236C182 450.725 182.968 450.223 185.387 450.223C187.807 450.223 290.399 449.721 293.786 450.223C297.174 450.725 297.174 452.232 297.658 453.236C298.141 454.24 305.884 507.963 304.916 511.979C303.949 515.996 303.465 515.494 301.529 515.996Z",
    fill: "url(#paint9_linear_4903_18626)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M305.529 515.996C303.593 516.498 195.195 517 195.195 517C195.195 517 191.807 517 190.839 514.49C189.871 511.979 186 455.746 186 453.236C186 450.725 186.968 450.223 189.387 450.223C191.807 450.223 294.399 449.721 297.786 450.223C301.174 450.725 301.174 452.232 301.658 453.236C302.141 454.24 309.884 507.963 308.916 511.979C307.949 515.996 307.465 515.494 305.529 515.996Z",
    fill: "url(#paint10_linear_4903_18626)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294.5 516.277V450.109C289.216 450.022 278.239 449.995 265.291 450.001L216.841 516.888C240.18 516.759 276.413 516.531 294.5 516.277Z",
    fill: "url(#paint11_linear_4903_18626)",
    fillOpacity: 0.75
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 4,
    transform: "matrix(1 0 0 -1 217 444.5)",
    fill: "url(#paint12_linear_4903_18626)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M241.5 440L237 470H261L268.5 440H241.5Z",
    fill: "url(#paint13_linear_4903_18626)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M234.5 455L237 470L241.5 440.5H235L234.5 455Z",
    fill: "url(#paint14_linear_4903_18626)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M472.5 495L392 486V290.5H468L472.5 495Z",
    fill: "url(#paint15_linear_4903_18626)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M586.5 493L472.5 495L468 290.5L569.5 290L586.5 493Z",
    fill: "url(#paint16_linear_4903_18626)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M511.382 514.25C511.081 513.288 510.195 511.306 509.414 509.846C507.166 505.649 507.629 500.585 510.581 497.077C513.112 494.069 513.368 494 521.992 494C530.616 494 530.872 494.069 533.403 497.077C536.355 500.585 536.818 505.649 534.57 509.846C533.789 511.306 532.903 513.288 532.602 514.25C532.128 515.764 530.701 516 521.992 516C513.283 516 511.856 515.764 511.382 514.25Z",
    fill: "#33193B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M511.382 514.25C511.081 513.288 510.195 511.306 509.414 509.846C507.166 505.649 507.629 500.585 510.581 497.077C513.112 494.069 513.368 494 521.992 494C530.616 494 530.872 494.069 533.403 497.077C536.355 500.585 536.818 505.649 534.57 509.846C533.789 511.306 532.903 513.288 532.602 514.25C532.128 515.764 530.701 516 521.992 516C513.283 516 511.856 515.764 511.382 514.25Z",
    fill: "url(#paint17_linear_4903_18626)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M577 486.5L480 487.5V444.5L574 443.5L577 486.5Z",
    fill: "#DE5D59"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M577 484.5L480 485.5V442.5L574 441.5L577 484.5Z",
    fill: "url(#paint18_linear_4903_18626)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M493.537 503.205C493.401 502.768 492.998 501.867 492.643 501.203C491.621 499.295 491.831 496.993 493.173 495.399C494.324 494.032 494.44 494 498.36 494C502.28 494 502.396 494.032 503.547 495.399C504.889 496.993 505.099 499.295 504.077 501.203C503.722 501.867 503.32 502.768 503.183 503.205C502.967 503.893 502.319 504 498.36 504C494.401 504 493.753 503.893 493.537 503.205Z",
    fill: "#33193B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M493.537 503.205C493.401 502.768 492.998 501.867 492.643 501.203C491.621 499.295 491.831 496.993 493.173 495.399C494.324 494.032 494.44 494 498.36 494C502.28 494 502.396 494.032 503.547 495.399C504.889 496.993 505.099 499.295 504.077 501.203C503.722 501.867 503.32 502.768 503.183 503.205C502.967 503.893 502.319 504 498.36 504C494.401 504 493.753 503.893 493.537 503.205Z",
    fill: "url(#paint19_linear_4903_18626)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M573 436L480 437V394L570 393L573 436Z",
    fill: "#DE5D59"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M573 434L480 435V392L570 391L573 434Z",
    fill: "url(#paint20_linear_4903_18626)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M569 386L480 387V344L566 343L569 386Z",
    fill: "#DE5D59"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M566 341L480 342V299L563.101 298L566 341Z",
    fill: "url(#paint21_linear_4903_18626)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M569 384L480 385V342L566 341L569 384Z",
    fill: "url(#paint22_linear_4903_18626)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M493 539.934C493 539.35 492.213 538.951 491.25 539.049C485.699 539.614 484.091 537.267 489.074 535.874C491.313 535.249 491.263 535.189 488.417 535.097C484.631 534.974 483.653 534.12 485.186 532.273C486.151 531.11 485.851 530.921 483.462 531.181C481.353 531.412 480.474 531.024 480.212 529.747C479.944 528.441 480.506 527.997 482.427 527.997C484.047 527.997 485 527.442 485 526.497C485 525.672 485.675 524.997 486.5 524.997C487.537 524.997 488 526.039 488 528.375C488 530.232 488.675 532.312 489.5 532.997C490.753 534.037 491 533.893 491 532.119C491 529.206 492.622 529.458 496.653 532.997C499.891 535.84 502 536.771 502 535.357C502 535.005 501.256 534.174 500.347 533.509C499.438 532.844 499.015 531.782 499.406 531.149C500.531 529.329 503.752 529.805 505.303 532.019C506.213 533.319 507.322 533.811 508.403 533.396C509.979 532.791 509.98 532.632 508.407 530.894C506.889 529.217 506.88 528.98 508.316 528.429C509.19 528.094 510.286 528.056 510.752 528.344C511.218 528.632 512.108 528.054 512.728 527.06C513.666 525.56 513.468 525.076 511.567 524.21C510.308 523.636 509.045 522.278 508.762 521.193C508.302 519.435 508.645 519.274 511.915 519.712C515.076 520.136 515.739 519.866 516.698 517.761C517.486 516.032 518.497 515.392 520.156 515.574C521.445 515.715 522.886 515.868 523.358 515.914C523.831 515.959 523.939 517.104 523.599 518.457C523.137 520.301 523.49 521.189 525.012 522.003C527.738 523.462 529.297 522.42 528.003 520.002C527.451 518.972 527.018 517.311 527.04 516.313C527.07 514.974 527.484 515.242 528.617 517.333C530.038 519.954 530.285 520.049 531.905 518.583C532.869 517.71 534.649 516.997 535.86 516.997C538.315 516.997 539.815 519.582 538.261 521.136C536.426 522.971 539.157 526.98 542.247 526.989C544.389 526.995 545.31 526.281 546.427 523.747C547.792 520.653 547.893 520.605 548.547 522.747C549.393 525.519 550.029 525.551 552.811 522.958C555.148 520.781 555.651 518.487 553.975 517.655C553.411 517.376 553.524 517.261 554.225 517.4C556.663 517.885 556.193 521.7 553.427 523.876C551.284 525.561 550.981 526.27 551.921 527.402C553.682 529.524 551.388 530.478 548.706 528.739C545.237 526.489 543.605 527.679 545.994 530.717C548.601 534.03 548.53 535.211 545.75 534.817C544.364 534.62 542.924 533.258 542 531.269C540.131 527.245 537.812 526.926 538.212 530.747C538.44 532.926 538.085 533.497 536.5 533.497C535.062 533.497 534.411 532.725 534.184 530.747C533.824 527.618 533.687 527.551 531.042 529.203C529.466 530.187 528.766 530.095 527.227 528.703C524.975 526.664 524 526.54 524 528.29C524 529.001 525.462 530.014 527.248 530.54C531.049 531.66 532.24 534.86 529.156 535.666C528.046 535.957 527.358 536.766 527.626 537.464C528.271 539.146 523.984 540.228 522.28 538.814C521.186 537.907 521.221 537.309 522.477 535.391C524.523 532.27 524.511 530.328 522.458 532.032C521.374 532.932 520.601 532.998 519.858 532.255C518.54 530.937 519.691 526.997 521.394 526.997C522.225 526.997 522.504 525.975 522.213 523.997C521.971 522.347 521.411 520.997 520.968 520.997C520.526 520.997 519.339 520.696 518.332 520.327C516.582 519.688 516.578 519.747 518.25 521.656C521.546 525.42 519.597 528.927 515.977 525.747C515.194 525.059 515.329 525.432 516.277 526.576C519.561 530.537 517.905 534.06 513.771 531.908L511.5 530.726L513.75 533.176C517.86 537.652 515.728 539.969 511.314 535.823C509.02 533.667 509 533.666 509 535.7C509 536.829 508.35 538.292 507.555 538.951C505.86 540.358 501.411 539.932 501.694 538.39C502.054 536.431 496.184 537.185 495.667 539.164C495.158 541.109 493 541.732 493 539.934ZM481.25 526.335C480.563 526.057 480 524.418 480 522.691C480 519.755 480.086 519.68 481.334 521.524C484.275 525.874 484.246 527.544 481.25 526.335ZM493 518.466C493 517.623 493.675 516.675 494.5 516.359C496.703 515.513 496.328 512.997 494 512.997C490.962 512.997 491.376 509.192 494.5 508.408C495.875 508.063 497 507.379 497 506.889C497 505.524 494.607 505.827 492.441 507.465C489.943 509.355 488 509.39 488 507.547C488 506.749 487.216 505.658 486.258 505.122C483.105 503.357 485.852 502.699 489.38 504.373C491.764 505.504 492.889 504.596 494.5 504C495.784 503.525 497.855 503.32 498.492 503.545C499.129 503.77 499.643 504.079 500 503.5C500.981 501.913 504 502.786 504 504.497C504 505.322 503.55 505.997 503 505.997C501.145 505.997 501.982 507.759 504.101 508.313C505.256 508.615 505.917 509.323 505.569 509.886C505.221 510.449 504.275 510.656 503.468 510.346C501.189 509.472 501.739 511.57 504.25 513.331C506.172 514.679 506.282 515.057 505 515.927C503.874 516.691 503.409 516.525 503.137 515.262C502.635 512.94 499.959 508.997 498.885 508.997C497.669 508.997 497.764 512.733 499 513.497C500.501 514.425 500.214 517.293 498.678 516.704C497.951 516.425 496.822 517.052 496.17 518.097C494.742 520.383 493 520.586 493 518.466ZM505 500.48C505 499.756 505.563 498.937 506.25 498.659C506.938 498.382 506.514 498.119 505.309 498.076C504.104 498.033 502.816 497.508 502.446 496.91C501.312 495.074 503.902 493.497 508.051 493.497C511.899 493.497 513.26 494.39 510.75 495.268C509.845 495.584 510.01 496.28 511.348 497.788C512.364 498.934 512.928 500.304 512.601 500.834C511.673 502.335 505 502.024 505 500.48ZM534 495.414C534 493.648 536.153 493.955 536.771 495.809C536.989 496.463 536.454 496.997 535.583 496.997C534.712 496.997 534 496.285 534 495.414Z",
    fill: "#576040"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M493 539.934C493 539.35 492.213 538.951 491.25 539.049C485.699 539.614 484.091 537.267 489.074 535.874C491.313 535.249 491.263 535.189 488.417 535.097C484.631 534.974 483.653 534.12 485.186 532.273C486.151 531.11 485.851 530.921 483.462 531.181C481.353 531.412 480.474 531.024 480.212 529.747C479.944 528.441 480.506 527.997 482.427 527.997C484.047 527.997 485 527.442 485 526.497C485 525.672 485.675 524.997 486.5 524.997C487.537 524.997 488 526.039 488 528.375C488 530.232 488.675 532.312 489.5 532.997C490.753 534.037 491 533.893 491 532.119C491 529.206 492.622 529.458 496.653 532.997C499.891 535.84 502 536.771 502 535.357C502 535.005 501.256 534.174 500.347 533.509C499.438 532.844 499.015 531.782 499.406 531.149C500.531 529.329 503.752 529.805 505.303 532.019C506.213 533.319 507.322 533.811 508.403 533.396C509.979 532.791 509.98 532.632 508.407 530.894C506.889 529.217 506.88 528.98 508.316 528.429C509.19 528.094 510.286 528.056 510.752 528.344C511.218 528.632 512.108 528.054 512.728 527.06C513.666 525.56 513.468 525.076 511.567 524.21C510.308 523.636 509.045 522.278 508.762 521.193C508.302 519.435 508.645 519.274 511.915 519.712C515.076 520.136 515.739 519.866 516.698 517.761C517.486 516.032 518.497 515.392 520.156 515.574C521.445 515.715 522.886 515.868 523.358 515.914C523.831 515.959 523.939 517.104 523.599 518.457C523.137 520.301 523.49 521.189 525.012 522.003C527.738 523.462 529.297 522.42 528.003 520.002C527.451 518.972 527.018 517.311 527.04 516.313C527.07 514.974 527.484 515.242 528.617 517.333C530.038 519.954 530.285 520.049 531.905 518.583C532.869 517.71 534.649 516.997 535.86 516.997C538.315 516.997 539.815 519.582 538.261 521.136C536.426 522.971 539.157 526.98 542.247 526.989C544.389 526.995 545.31 526.281 546.427 523.747C547.792 520.653 547.893 520.605 548.547 522.747C549.393 525.519 550.029 525.551 552.811 522.958C555.148 520.781 555.651 518.487 553.975 517.655C553.411 517.376 553.524 517.261 554.225 517.4C556.663 517.885 556.193 521.7 553.427 523.876C551.284 525.561 550.981 526.27 551.921 527.402C553.682 529.524 551.388 530.478 548.706 528.739C545.237 526.489 543.605 527.679 545.994 530.717C548.601 534.03 548.53 535.211 545.75 534.817C544.364 534.62 542.924 533.258 542 531.269C540.131 527.245 537.812 526.926 538.212 530.747C538.44 532.926 538.085 533.497 536.5 533.497C535.062 533.497 534.411 532.725 534.184 530.747C533.824 527.618 533.687 527.551 531.042 529.203C529.466 530.187 528.766 530.095 527.227 528.703C524.975 526.664 524 526.54 524 528.29C524 529.001 525.462 530.014 527.248 530.54C531.049 531.66 532.24 534.86 529.156 535.666C528.046 535.957 527.358 536.766 527.626 537.464C528.271 539.146 523.984 540.228 522.28 538.814C521.186 537.907 521.221 537.309 522.477 535.391C524.523 532.27 524.511 530.328 522.458 532.032C521.374 532.932 520.601 532.998 519.858 532.255C518.54 530.937 519.691 526.997 521.394 526.997C522.225 526.997 522.504 525.975 522.213 523.997C521.971 522.347 521.411 520.997 520.968 520.997C520.526 520.997 519.339 520.696 518.332 520.327C516.582 519.688 516.578 519.747 518.25 521.656C521.546 525.42 519.597 528.927 515.977 525.747C515.194 525.059 515.329 525.432 516.277 526.576C519.561 530.537 517.905 534.06 513.771 531.908L511.5 530.726L513.75 533.176C517.86 537.652 515.728 539.969 511.314 535.823C509.02 533.667 509 533.666 509 535.7C509 536.829 508.35 538.292 507.555 538.951C505.86 540.358 501.411 539.932 501.694 538.39C502.054 536.431 496.184 537.185 495.667 539.164C495.158 541.109 493 541.732 493 539.934ZM481.25 526.335C480.563 526.057 480 524.418 480 522.691C480 519.755 480.086 519.68 481.334 521.524C484.275 525.874 484.246 527.544 481.25 526.335ZM493 518.466C493 517.623 493.675 516.675 494.5 516.359C496.703 515.513 496.328 512.997 494 512.997C490.962 512.997 491.376 509.192 494.5 508.408C495.875 508.063 497 507.379 497 506.889C497 505.524 494.607 505.827 492.441 507.465C489.943 509.355 488 509.39 488 507.547C488 506.749 487.216 505.658 486.258 505.122C483.105 503.357 485.852 502.699 489.38 504.373C491.764 505.504 492.889 504.596 494.5 504C495.784 503.525 497.855 503.32 498.492 503.545C499.129 503.77 499.643 504.079 500 503.5C500.981 501.913 504 502.786 504 504.497C504 505.322 503.55 505.997 503 505.997C501.145 505.997 501.982 507.759 504.101 508.313C505.256 508.615 505.917 509.323 505.569 509.886C505.221 510.449 504.275 510.656 503.468 510.346C501.189 509.472 501.739 511.57 504.25 513.331C506.172 514.679 506.282 515.057 505 515.927C503.874 516.691 503.409 516.525 503.137 515.262C502.635 512.94 499.959 508.997 498.885 508.997C497.669 508.997 497.764 512.733 499 513.497C500.501 514.425 500.214 517.293 498.678 516.704C497.951 516.425 496.822 517.052 496.17 518.097C494.742 520.383 493 520.586 493 518.466ZM505 500.48C505 499.756 505.563 498.937 506.25 498.659C506.938 498.382 506.514 498.119 505.309 498.076C504.104 498.033 502.816 497.508 502.446 496.91C501.312 495.074 503.902 493.497 508.051 493.497C511.899 493.497 513.26 494.39 510.75 495.268C509.845 495.584 510.01 496.28 511.348 497.788C512.364 498.934 512.928 500.304 512.601 500.834C511.673 502.335 505 502.024 505 500.48ZM534 495.414C534 493.648 536.153 493.955 536.771 495.809C536.989 496.463 536.454 496.997 535.583 496.997C534.712 496.997 534 496.285 534 495.414Z",
    fill: "url(#paint23_linear_4903_18626)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M496 477C496 477.553 496.448 478 497 478H502C502.552 478 503 477.553 503 477V445H496V477Z",
    fill: "url(#paint24_linear_4903_18626)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M505 443H494V477C494 478.657 495.343 480 497 480H502C503.657 480 505 478.657 505 477V443ZM497 478C496.448 478 496 477.553 496 477V445H503V477C503 477.553 502.552 478 502 478H497Z",
    fill: "url(#paint25_linear_4903_18626)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M497 478H498V445H497V478Z",
    fill: "url(#paint26_linear_4903_18626)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M499 478H500V445H499V478Z",
    fill: "url(#paint27_linear_4903_18626)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M501 478H502V445H501V478Z",
    fill: "url(#paint28_linear_4903_18626)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M507 477C507 477.553 507.448 478 508 478H513C513.552 478 514 477.553 514 477V445H507V477Z",
    fill: "url(#paint29_linear_4903_18626)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M516 443H505V477C505 478.657 506.343 480 508 480H513C514.657 480 516 478.657 516 477V443ZM508 478C507.448 478 507 477.553 507 477V445H514V477C514 477.553 513.552 478 513 478H508Z",
    fill: "url(#paint30_linear_4903_18626)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M508 478H509V445H508V478Z",
    fill: "url(#paint31_linear_4903_18626)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M510 478H511V445H510V478Z",
    fill: "url(#paint32_linear_4903_18626)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M512 478H513V445H512V478Z",
    fill: "url(#paint33_linear_4903_18626)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M482 426C482 426.553 482.448 427 483 427H488C488.552 427 489 426.553 489 426V394H482V426Z",
    fill: "url(#paint34_linear_4903_18626)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M491 392H480V426C480 427.657 481.343 429 483 429H488C489.657 429 491 427.657 491 426V392ZM483 427C482.448 427 482 426.553 482 426V394H489V426C489 426.553 488.552 427 488 427H483Z",
    fill: "url(#paint35_linear_4903_18626)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M483 427H484V394H483V427Z",
    fill: "url(#paint36_linear_4903_18626)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M485 427H486V394H485V427Z",
    fill: "url(#paint37_linear_4903_18626)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M487 427H488V394H487V427Z",
    fill: "url(#paint38_linear_4903_18626)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M493 426C493 426.553 493.448 427 494 427H499C499.552 427 500 426.553 500 426V394H493V426Z",
    fill: "url(#paint39_linear_4903_18626)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502 392H491V426C491 427.657 492.343 429 494 429H499C500.657 429 502 427.657 502 426V392ZM494 427C493.448 427 493 426.553 493 426V394H500V426C500 426.553 499.552 427 499 427H494Z",
    fill: "url(#paint40_linear_4903_18626)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M494 427H495V394H494V427Z",
    fill: "url(#paint41_linear_4903_18626)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M496 427H497V394H496V427Z",
    fill: "url(#paint42_linear_4903_18626)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M498 427H499V394H498V427Z",
    fill: "url(#paint43_linear_4903_18626)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M504 426C504 426.553 504.448 427 505 427H510C510.552 427 511 426.553 511 426V394H504V426Z",
    fill: "url(#paint44_linear_4903_18626)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M513 392H502V426C502 427.657 503.343 429 505 429H510C511.657 429 513 427.657 513 426V392ZM505 427C504.448 427 504 426.553 504 426V394H511V426C511 426.553 510.552 427 510 427H505Z",
    fill: "url(#paint45_linear_4903_18626)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M505 427H506V394H505V427Z",
    fill: "url(#paint46_linear_4903_18626)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M507 427H508V394H507V427Z",
    fill: "url(#paint47_linear_4903_18626)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M509 427H510V394H509V427Z",
    fill: "url(#paint48_linear_4903_18626)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M547 394C547.552 394 548 394.448 548 395L548 400C548 400.553 547.552 401 547 401L515 401L515 394L547 394Z",
    fill: "url(#paint49_linear_4903_18626)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M513 403L513 392L547 392C548.657 392 550 393.343 550 395L550 400C550 401.657 548.657 403 547 403L513 403ZM548 395C548 394.448 547.552 394 547 394L515 394L515 401L547 401C547.552 401 548 400.553 548 400L548 395Z",
    fill: "url(#paint50_linear_4903_18626)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M548 395L548 396L515 396L515 395L548 395Z",
    fill: "url(#paint51_linear_4903_18626)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M548 397L548 398L515 398L515 397L548 397Z",
    fill: "url(#paint52_linear_4903_18626)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M548 399L548 400L515 400L515 399L548 399Z",
    fill: "url(#paint53_linear_4903_18626)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M514 344C514.552 344 515 344.448 515 345L515 350C515 350.553 514.552 351 514 351L482 351L482 344L514 344Z",
    fill: "url(#paint54_linear_4903_18626)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M480 353L480 342L514 342C515.657 342 517 343.343 517 345L517 350C517 351.657 515.657 353 514 353L480 353ZM515 345C515 344.448 514.552 344 514 344L482 344L482 351L514 351C514.552 351 515 350.553 515 350L515 345Z",
    fill: "url(#paint55_linear_4903_18626)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M515 345L515 346L482 346L482 345L515 345Z",
    fill: "url(#paint56_linear_4903_18626)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M515 347L515 348L482 348L482 347L515 347Z",
    fill: "url(#paint57_linear_4903_18626)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M515 349L515 350L482 350L482 349L515 349Z",
    fill: "url(#paint58_linear_4903_18626)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M527.062 375.958C527.05 376.51 526.593 376.948 526.041 376.936L521.042 376.828C520.49 376.816 520.052 376.359 520.064 375.807L520.753 343.814L527.752 343.965L527.062 375.958Z",
    fill: "url(#paint59_linear_4903_18626)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M518.797 341.772L529.794 342.009L529.062 376.001C529.026 377.657 527.654 378.971 525.998 378.936L520.999 378.828C519.342 378.792 518.029 377.42 518.064 375.764L518.797 341.772ZM526.041 376.936C526.593 376.948 527.05 376.51 527.062 375.958L527.752 343.965L520.753 343.814L520.064 375.807C520.052 376.359 520.49 376.816 521.042 376.828L526.041 376.936Z",
    fill: "url(#paint60_linear_4903_18626)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M526.041 376.936L525.041 376.915L525.752 343.922L526.752 343.944L526.041 376.936Z",
    fill: "url(#paint61_linear_4903_18626)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M524.041 376.893L523.042 376.871L523.753 343.879L524.752 343.901L524.041 376.893Z",
    fill: "url(#paint62_linear_4903_18626)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M522.042 376.85L521.042 376.828L521.753 343.836L522.753 343.858L522.042 376.85Z",
    fill: "url(#paint63_linear_4903_18626)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M539.062 375.958C539.05 376.51 538.593 376.948 538.041 376.936L533.042 376.828C532.49 376.816 532.052 376.359 532.064 375.807L532.753 343.814L539.752 343.965L539.062 375.958Z",
    fill: "url(#paint64_linear_4903_18626)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M530.797 341.772L541.794 342.009L541.062 376.001C541.026 377.657 539.654 378.971 537.998 378.936L532.999 378.828C531.342 378.792 530.029 377.42 530.064 375.764L530.797 341.772ZM538.041 376.936C538.593 376.948 539.05 376.51 539.062 375.958L539.752 343.965L532.753 343.814L532.064 375.807C532.052 376.359 532.49 376.816 533.042 376.828L538.041 376.936Z",
    fill: "url(#paint65_linear_4903_18626)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M538.041 376.936L537.041 376.915L537.752 343.922L538.752 343.944L538.041 376.936Z",
    fill: "url(#paint66_linear_4903_18626)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M536.041 376.893L535.042 376.871L535.753 343.879L536.752 343.901L536.041 376.893Z",
    fill: "url(#paint67_linear_4903_18626)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M534.042 376.85L533.042 376.828L533.753 343.836L534.753 343.858L534.042 376.85Z",
    fill: "url(#paint68_linear_4903_18626)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M547.294 375.402C547.018 375.88 546.407 376.044 545.928 375.768L541.598 373.268C541.12 372.992 540.956 372.38 541.232 371.902L557.232 344.189L563.294 347.689L547.294 375.402Z",
    fill: "url(#paint69_linear_4903_18626)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M556.5 341.457L566.026 346.957L549.026 376.402C548.198 377.837 546.363 378.329 544.928 377.5L540.598 375C539.163 374.172 538.672 372.337 539.5 370.902L556.5 341.457ZM545.928 375.768C546.407 376.044 547.018 375.88 547.294 375.402L563.294 347.689L557.232 344.189L541.232 371.902C540.956 372.38 541.12 372.992 541.598 373.268L545.928 375.768Z",
    fill: "url(#paint70_linear_4903_18626)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M545.928 375.768L545.062 375.268L561.562 346.689L562.428 347.189L545.928 375.768Z",
    fill: "url(#paint71_linear_4903_18626)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M544.196 374.768L543.33 374.268L559.83 345.689L560.696 346.189L544.196 374.768Z",
    fill: "url(#paint72_linear_4903_18626)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M542.464 373.768L541.598 373.268L558.098 344.689L558.964 345.189L542.464 373.768Z",
    fill: "url(#paint73_linear_4903_18626)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M540.605 473.441C540.981 473.846 541.614 473.869 542.018 473.493L545.682 470.09C546.086 469.714 546.11 469.082 545.734 468.677L523.955 445.232L518.826 449.996L540.605 473.441Z",
    fill: "url(#paint74_linear_4903_18626)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M524.059 442.405L516 449.892L539.14 474.802C540.268 476.016 542.166 476.086 543.38 474.958L547.043 471.556C548.257 470.428 548.327 468.53 547.199 467.316L524.059 442.405ZM542.018 473.493C541.614 473.869 540.981 473.846 540.605 473.441L518.826 449.996L523.955 445.232L545.734 468.677C546.11 469.082 546.086 469.714 545.682 470.09L542.018 473.493Z",
    fill: "url(#paint75_linear_4903_18626)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M542.018 473.493L542.751 472.813L520.292 448.635L519.559 449.315L542.018 473.493Z",
    fill: "url(#paint76_linear_4903_18626)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M543.484 472.132L544.216 471.451L521.757 447.273L521.024 447.954L543.484 472.132Z",
    fill: "url(#paint77_linear_4903_18626)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M544.949 470.771L545.682 470.09L523.222 445.912L522.49 446.593L544.949 470.771Z",
    fill: "url(#paint78_linear_4903_18626)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M551 476C551 476.553 551.448 477 552 477H557C557.552 477 558 476.553 558 476V444H551V476Z",
    fill: "url(#paint79_linear_4903_18626)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560 442H549V476C549 477.657 550.343 479 552 479H557C558.657 479 560 477.657 560 476V442ZM552 477C551.448 477 551 476.553 551 476V444H558V476C558 476.553 557.552 477 557 477H552Z",
    fill: "url(#paint80_linear_4903_18626)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M552 477H553V444H552V477Z",
    fill: "url(#paint81_linear_4903_18626)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M554 477H555V444H554V477Z",
    fill: "url(#paint82_linear_4903_18626)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M556 477H557V444H556V477Z",
    fill: "url(#paint83_linear_4903_18626)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M429 444H388C388 444 390.47 442.449 392.94 442.138C395.41 441.828 422.084 442.138 424.06 442.138C426.036 442.138 429 444 429 444Z",
    fill: "url(#paint84_linear_4903_18626)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M425 442H384C384 442 386.47 440.449 388.94 440.138C391.41 439.828 418.084 440.138 420.06 440.138C422.036 440.138 425 442 425 442Z",
    fill: "url(#paint85_linear_4903_18626)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M433 443H388C388 443 390.711 441.449 393.422 441.138C396.133 440.828 425.41 441.138 427.578 441.138C429.747 441.138 433 443 433 443Z",
    fill: "url(#paint86_linear_4903_18626)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M433 443H388C388 443 390.711 442.612 393.422 442.535C396.133 442.457 425.41 442.535 427.578 442.535C429.747 442.535 433 443 433 443Z",
    fill: "url(#paint87_linear_4903_18626)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M435 442H387C387 442 389.892 440.449 392.783 440.138C395.675 439.828 426.904 440.138 429.217 440.138C431.53 440.138 435 442 435 442Z",
    fill: "url(#paint88_linear_4903_18626)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M433 442H388C388 442 390.711 441.612 393.422 441.535C396.133 441.457 425.41 441.535 427.578 441.535C429.747 441.535 433 442 433 442Z",
    fill: "url(#paint89_linear_4903_18626)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 336,
    height: 12,
    transform: "matrix(1 0 0 -1 87 302)",
    fill: "url(#paint90_linear_4903_18626)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: -1,
    width: 334,
    height: 10,
    transform: "matrix(1 0 0 -1 87 300)",
    stroke: "url(#paint91_linear_4903_18626)",
    strokeOpacity: 0.2,
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 300,
    width: 64,
    height: 10,
    transform: "rotate(-180 87 300)",
    fill: "url(#paint92_linear_4903_18626)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M440.5 431.5L429.5 299.5L85.5 299L79 431.5H440.5Z",
    fill: "url(#paint93_linear_4903_18626)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 78.6871,
    height: 58.7217,
    transform: "matrix(1 0 0 -1 163 394)",
    fill: "url(#pattern0)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 97.8553,
    height: 38.1348,
    transform: "matrix(1 0 0 -1 259.667 384.245)",
    fill: "url(#pattern1)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2162 442.546C97.44 442.546 96.8108 443.116 96.8108 443.818L96.8108 450.182C96.8108 450.885 97.44 451.455 98.2162 451.455L146 451.455L146 442.546L98.2162 442.546Z",
    fill: "url(#paint94_linear_4903_18626)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146 454L146 440L98.2162 440C95.8877 440 94 441.71 94 443.818L94 450.182C94 452.291 95.8877 454 98.2162 454L146 454ZM96.8108 443.818C96.8108 443.116 97.44 442.546 98.2162 442.546L146 442.546L146 451.455L98.2162 451.455C97.44 451.455 96.8108 450.885 96.8108 450.182L96.8108 443.818Z",
    fill: "url(#paint95_linear_4903_18626)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8108 443.818L96.8108 445.091L146.189 445.091L146.189 443.818L96.8108 443.818Z",
    fill: "url(#paint96_linear_4903_18626)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8108 446.364L96.8108 447.637L146.189 447.637L146.189 446.364L96.8108 446.364Z",
    fill: "url(#paint97_linear_4903_18626)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8108 448.909L96.8108 450.182L146.189 450.182L146.189 448.909L96.8108 448.909Z",
    fill: "url(#paint98_linear_4903_18626)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M439.667 421.5L440.5 431.5H79L79.4906 421.5H439.667Z",
    fill: "url(#paint99_linear_4903_18626)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M452.5 440.5H77.5V428.5H451L452.5 440.5Z",
    fill: "url(#paint100_linear_4903_18626)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5 440.5H77.5V428.5H79.492L79.5 440.5Z",
    fill: "url(#paint101_linear_4903_18626)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M451 440.5H449V428.5H450.992L451 440.5Z",
    fill: "url(#paint102_linear_4903_18626)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5 428.5V440.5L0 439.5L2 428.5H77.5Z",
    fill: "url(#paint103_linear_4903_18626)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5 299L80 428.5H10L23.5 299H86.5Z",
    fill: "url(#paint104_linear_4903_18626)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M332.5 449L327.5 440.5H376.5L371 449H332.5Z",
    fill: "url(#paint105_linear_4903_18626)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 3.76877,
    height: 30.1379,
    transform: "matrix(0.975424 0.220335 0.220335 -0.975424 78.7812 481.483)",
    fill: "#FCFCFC"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 3.76877,
    height: 10.5617,
    transform: "matrix(0.975424 0.220335 0.220335 -0.975424 78.4723 482.848)",
    fill: "#885E95"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 3.76877,
    height: 28.4752,
    transform: "matrix(0.975424 0.220335 0.220335 -0.975424 78.7327 481.707)",
    fill: "#1F1628"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 1.25626,
    height: 28.4752,
    transform: "matrix(0.975424 0.220335 0.220335 -0.975424 79.9584 481.984)",
    fill: "#361C40"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 1.25626,
    height: 28.4752,
    transform: "matrix(0.975424 0.220335 0.220335 -0.975424 81.1837 482.261)",
    fill: "#573661"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4903_18626",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 85,
    y: 448,
    width: 5,
    height: 6
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0217 449.439C86.1745 448.762 86.8471 448.337 87.5238 448.49L88.7492 448.767C89.426 448.92 89.8507 449.592 89.6978 450.269L88.8674 453.945L85.1913 453.115L86.0217 449.439Z",
    fill: "#F15642"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4903_18626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.4169 453.392L87.6422 453.668L88.7494 448.767L87.524 448.49L86.4169 453.392Z",
    fill: "#DC695A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1915 453.115L86.4169 453.392L87.524 448.49L86.2987 448.213L85.1915 453.115Z",
    fill: "#B56B61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6422 453.668L88.8676 453.945L89.9748 449.044L88.7494 448.767L87.6422 453.668Z",
    fill: "#ED8173"
  }))), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1848 486.545C79.256 486.901 79.7139 487.004 79.9307 486.714L82.0721 483.85C82.2538 483.607 82.1249 483.258 81.8291 483.191L78.9851 482.549C78.6892 482.482 78.4226 482.742 78.4822 483.039L79.1848 486.545Z",
    fill: "#EDAFA1"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.4095 486.076C80.2387 485.911 80.0203 485.787 79.7632 485.729C79.5058 485.671 79.2552 485.689 79.0299 485.765L79.1863 486.546C79.2575 486.901 79.7154 487.004 79.9323 486.714L80.4095 486.076Z",
    fill: "#56575B"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 3.76877,
    height: 30.1379,
    transform: "matrix(0.997134 0.0756536 0.0756536 -0.997134 85.9673 475.984)",
    fill: "#FCFCFC"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 3.76877,
    height: 10.5617,
    transform: "matrix(0.997134 0.0756536 0.0756536 -0.997134 85.861 477.38)",
    fill: "#B4454C"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 3.76877,
    height: 28.4752,
    transform: "matrix(0.997134 0.0756536 0.0756536 -0.997134 85.9521 476.213)",
    fill: "#802E33"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 1.25626,
    height: 28.4752,
    transform: "matrix(0.997134 0.0756536 0.0756536 -0.997134 87.2051 476.308)",
    fill: "#C44B46"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 1.25626,
    height: 28.4752,
    transform: "matrix(0.997134 0.0756536 0.0756536 -0.997134 88.4576 476.403)",
    fill: "#DE5D59"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4903_18626",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 88,
    y: 442,
    width: 5,
    height: 6
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4548 443.227C88.5073 442.535 89.1107 442.016 89.8025 442.069L91.0552 442.164C91.747 442.216 92.2653 442.82 92.2128 443.512L91.9277 447.27L88.1697 446.985L88.4548 443.227Z",
    fill: "#F15642"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4903_18626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.4225 447.079L90.6751 447.174L91.0553 442.164L89.8026 442.069L89.4225 447.079Z",
    fill: "#DC695A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1698 446.984L89.4225 447.079L89.8026 442.069L88.55 441.974L88.1698 446.984Z",
    fill: "#B56B61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6751 447.174L91.9278 447.269L92.3079 442.259L91.0553 442.164L90.6751 447.174Z",
    fill: "#ED8173"
  }))), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1053 480.934C87.2275 481.275 87.6956 481.31 87.8679 480.992L89.5685 477.846C89.7128 477.579 89.5343 477.252 89.2318 477.229L86.3246 477.009C86.0221 476.986 85.7963 477.282 85.8987 477.568L87.1053 480.934Z",
    fill: "#EDAFA1"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.2484 480.29C88.0553 480.152 87.8213 480.062 87.5585 480.042C87.2953 480.022 87.05 480.076 86.8381 480.184L87.1068 480.934C87.2291 481.275 87.6971 481.31 87.8694 480.991L88.2484 480.29Z",
    fill: "#56575B"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 3.76877,
    height: 23.8764,
    transform: "matrix(0.980653 -0.195754 -0.195754 -0.980653 97.8168 468.351)",
    fill: "#FCFCFC"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 3.76877,
    height: 8.36734,
    transform: "matrix(0.980653 -0.195754 -0.195754 -0.980653 98.0333 469.438)",
    fill: "#B4454C"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 3.76877,
    height: 22.5591,
    transform: "matrix(0.980653 -0.195754 -0.195754 -0.980653 97.8543 468.528)",
    fill: "#802E33"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 1.25626,
    height: 22.5591,
    transform: "matrix(0.980653 -0.195754 -0.195754 -0.980653 99.0867 468.282)",
    fill: "#C44B46"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 1.25626,
    height: 22.5591,
    transform: "matrix(0.980653 -0.195754 -0.195754 -0.980653 100.318 468.036)",
    fill: "#DE5D59"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_4903_18626",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 92,
    y: 441,
    width: 6,
    height: 5
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7748 443.083C92.639 442.403 93.0805 441.741 93.7609 441.605L94.9928 441.359C95.6732 441.223 96.3349 441.665 96.4707 442.345L97.0041 445.017L93.3082 445.755L92.7748 443.083Z",
    fill: "#F15642"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_4903_18626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.5399 445.509L95.7719 445.263L94.9926 441.359L93.7606 441.605L94.5399 445.509Z",
    fill: "#DC695A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.308 445.755L94.5399 445.509L93.7606 441.605L92.5287 441.851L93.308 445.755Z",
    fill: "#B56B61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7719 445.263L97.0038 445.017L96.2245 441.113L94.9926 441.359L95.7719 445.263Z",
    fill: "#ED8173"
  }))), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M100.072 471.85C100.285 472.097 100.686 472.017 100.787 471.707L101.666 469.022C101.765 468.718 101.5 468.419 101.186 468.482L98.466 469.024C98.1518 469.087 98.0215 469.465 98.2305 469.708L100.072 471.85Z",
    fill: "#EDAFA1"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.988 471.096C100.776 471.009 100.535 470.979 100.282 471.03C100.029 471.08 99.8169 471.2 99.6547 471.363L100.073 471.849C100.286 472.096 100.687 472.016 100.789 471.706L100.988 471.096Z",
    fill: "#56575B"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    width: 3.76877,
    height: 26.154,
    transform: "matrix(0.99632 -0.0857109 -0.0857109 -0.99632 96.0715 479.021)",
    fill: "#FCFCFC"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    width: 3.76877,
    height: 9.16552,
    transform: "matrix(0.99632 -0.0857109 -0.0857109 -0.99632 96.1758 480.231)",
    fill: "#885E95"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    width: 3.76877,
    height: 24.7111,
    transform: "matrix(0.99632 -0.0857109 -0.0857109 -0.99632 96.0914 479.219)",
    fill: "#1F1628"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    width: 1.25626,
    height: 24.7111,
    transform: "matrix(0.99632 -0.0857109 -0.0857109 -0.99632 97.3434 479.111)",
    fill: "#361C40"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    width: 1.25626,
    height: 24.7111,
    transform: "matrix(0.99632 -0.0857109 -0.0857109 -0.99632 98.5944 479.004)",
    fill: "#573661"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_4903_18626",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 93,
    y: 449,
    width: 5,
    height: 5
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6445 450.782C93.585 450.091 94.0972 449.482 94.7884 449.423L96.0401 449.315C96.7313 449.256 97.3399 449.768 97.3994 450.459L97.6655 453.552L93.9106 453.875L93.6445 450.782Z",
    fill: "#F15642"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_4903_18626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.1622 453.767L96.4138 453.66L96.04 449.315L94.7884 449.422L95.1622 453.767Z",
    fill: "#DC695A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9105 453.875L95.1622 453.767L94.7884 449.422L93.5368 449.53L93.9105 453.875Z",
    fill: "#B56B61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4138 453.66L97.6654 453.552L97.2917 449.207L96.04 449.315L96.4138 453.66Z",
    fill: "#ED8173"
  }))), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9477 483.103C98.129 483.391 98.5604 483.354 98.6897 483.039L99.8654 480.174C99.9844 479.884 99.7544 479.571 99.4421 479.597L96.6186 479.84C96.3063 479.867 96.1332 480.215 96.2999 480.48L97.9477 483.103Z",
    fill: "#EDAFA1"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.9568 482.393C98.7509 482.285 98.5103 482.231 98.2513 482.253C97.9917 482.275 97.7636 482.37 97.579 482.512L97.9499 483.103C98.1311 483.391 98.5626 483.354 98.6919 483.039L98.9568 482.393Z",
    fill: "#56575B"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.158 461.823C77.419 459.897 79.44 444.546 80.757 442.086C81.735 440.259 82.671 440.093 90.531 440.354L99.223 440.642L100.38 444.181C101.016 446.127 101.692 451.077 101.882 455.181L102.227 462.642C97.6309 462.752 95.0541 462.814 90.458 462.924C81.167 463.146 78.577 462.915 78.158 461.823Z",
    fill: "url(#paint106_linear_4903_18626)"
  }))), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.794 1.14078C143.554 3.1631 136.824 8.02265 133.293 12.3343C126.97 20.052 125.741 29.9853 129.387 43.8586C130.709 48.8855 131.559 55.2304 131.614 60.4625C131.614 60.4625 132.381 65.6944 131.704 68.9304C130.745 73.5081 130.782 73.7939 125.798 79.3319C120.814 84.8699 117.591 97.5477 122.282 111.717C125.62 121.8 128.204 125.793 133.534 129.109C137.543 131.601 170.963 143.238 175.943 143.875C179.22 144.294 180.115 143.851 184.7 139.536C192.694 132.011 194.088 128.596 193.996 116.749C193.933 108.463 193.284 104.44 190.142 92.8396C190.142 92.8396 187.385 84.4436 186.364 78.8926C184.463 68.5597 185.618 51.9947 185.618 51.9947C184.866 24.9474 184.124 19.2142 180.456 12.146C178.501 8.38029 174.295 4.42232 169.818 2.137C165.235 -0.203119 153.691 -0.750042 148.794 1.14078Z",
    fill: "#311739"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M152 72.159V59.6924L165 61.3924L165.5 69.1924L167 71.1924C167 72.3257 165.8 72.3857 165 73.2924C164.2 74.199 161.667 75.9368 160.5 76.6924L152 72.159Z",
    fill: "url(#paint107_linear_4903_18626)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.143 1.23434C145.98 2.04913 143.153 3.52912 141.86 4.52399C139.542 6.3051 139.53 6.39858 141.054 10.875C144.617 21.3383 154.028 31.8695 164.603 37.2236C169.559 39.7329 180.27 42.9586 183.786 43C186.629 43.0334 184.059 20.3178 180.395 13.0379C178.204 8.68549 174.259 4.74146 169.775 2.42306C164.659 -0.221055 153.62 -0.828208 148.143 1.23434Z",
    fill: "url(#paint108_linear_4903_18626)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.348 18.0424C157.616 19.2244 154.273 23.5174 150.92 27.5824L144.822 34.9724L144.866 43.6374C144.925 55.1184 146.553 57.9824 155.672 62.6424L162.822 65.6924L165.897 64.2224C167.807 63.1934 170.371 60.7414 171.596 58.7724C173.543 55.6414 175.814 53.8744 175.759 44.6924C175.69 33.0794 175.073 31.2494 168.115 22.0344C163.467 15.8784 160.116 15.1844 158.348 18.0424ZM137.333 37.1794C135.924 38.8764 136.528 42.2644 138.76 45.1924C140.075 46.9184 140.421 46.9874 141.288 45.6924C142.593 43.7424 142.592 40.0654 141.287 37.6264C140.045 35.3064 138.987 35.1864 137.333 37.1794Z",
    fill: "url(#paint109_linear_4903_18626)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M179.822 45.1924C182.054 42.2644 182.658 38.8764 181.249 37.1794C179.595 35.1864 180.242 35.3064 179 37.6264C177.695 40.0654 177.695 43.2424 179 45.1924C179.867 46.4874 178.507 46.9184 179.822 45.1924Z",
    fill: "url(#paint110_linear_4903_18626)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M149.145 72.5162C149.988 70.8542 151.102 68.9623 151.619 68.3122C151.896 67.9648 151.914 67.7615 152.013 67.7071C152.171 67.6206 152.537 67.9138 154.5 68.6073C156.801 69.4193 165.157 68.9263 166.429 68.6073C167.23 68.4067 167.323 68.6789 167.527 69.2779C167.75 69.9303 168.105 70.9702 169.651 72.2092C171.906 74.0162 178.064 77.7443 183.338 80.4943C191.134 84.5603 193.325 86.2173 195.065 89.3633C197.222 93.2623 197.566 94.6483 201.807 116.495C203.308 124.223 205.403 131.236 207.693 136.192C208.699 138.37 209.462 140.28 209.911 141.692H193.78C192.243 138.123 189.828 131.577 188.743 126.904C187.224 120.354 185.666 114.994 185.283 114.994C182.656 114.994 184.349 131.079 187.858 139.48C188.209 140.32 188.471 141.052 188.627 141.692H149.079C148.628 140.15 147.947 135.831 147.423 131.022C146.793 125.262 145.908 119.886 145.454 119.076C144.14 116.727 143.233 129.748 144.278 135.962C144.73 138.646 144.987 140.475 144.853 141.692H130.96C130.349 140.038 129.075 134.339 127.901 127.904C125.841 116.615 125.613 113.545 126.467 108.494C128.416 96.9432 129.694 92.4503 132.605 86.9012C135.168 82.0162 136.304 80.9443 141.576 78.4232C145.7 76.4523 148.099 74.5813 149.145 72.5162Z",
    fill: "#E5E1F4"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M180.684 79.0702C176.143 76.5693 171.535 73.7189 169.651 72.2092C168.105 70.9702 167.75 69.9303 167.527 69.2779C167.323 68.6789 167.23 68.4067 166.429 68.6073C165.157 68.9263 156.801 69.4193 154.5 68.6073C153.562 68.2757 152.988 68.0357 152.628 67.885C152.234 67.7203 152.096 67.662 152.013 67.7071C151.914 67.7615 151.896 67.9648 151.619 68.3122C151.103 68.9623 149.988 70.8542 149.146 72.5162C148.099 74.5813 145.7 76.4523 141.576 78.4232C137.488 80.3779 135.887 81.4614 134.18 84.1263C135.501 90.3388 144.317 92.4309 159.785 90.1689C174.087 88.0777 181.219 84.243 180.684 79.0702Z",
    fill: "url(#paint111_linear_4903_18626)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.794 125.963C146.293 122.4 145.77 119.638 145.455 119.076C145.335 118.86 145.217 118.774 145.104 118.801C143.8 111.426 143.31 102.845 143.501 97.3981L142.407 90.7792L145.561 97.3982C147.295 101.038 149.242 104.77 149.889 105.69C152.69 109.683 161.581 113.295 171.902 114.631C177.734 115.387 182.734 116.277 183.012 116.608C183.995 117.778 181.799 119.577 176.487 121.953C169.643 125.014 164.539 131.966 161.871 141.692H149.08C148.629 140.15 147.948 135.83 147.424 131.022C147.255 129.472 147.067 127.949 146.873 126.536C146.867 126.408 146.86 126.275 146.85 126.137C146.831 126.079 146.812 126.021 146.794 125.963Z",
    fill: "url(#paint112_linear_4903_18626)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.907 68.9976C161.385 69.0182 160.848 69.0337 160.31 69.0423C160.895 72.2999 162.31 76.9058 164.597 84.3489C165.107 86.0119 165.662 87.8165 166.26 89.7794L171.874 108.192L170.26 120.744C169.147 129.405 168.185 138.065 168.039 141.692H168.789C169.295 139.245 170.303 131.486 171.135 123.543L172.775 107.894L170.275 99.5434C164.419 79.9779 162.417 73.0713 161.907 68.9976Z",
    fill: "url(#paint113_linear_4903_18626)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.382 141.692H130.96C130.349 140.038 129.075 134.339 127.901 127.904C125.841 116.615 125.613 113.545 126.467 108.494C128.416 96.9432 129.694 92.4503 132.605 86.9012C134.407 83.4656 135.504 81.916 137.83 80.4219C137.873 80.4834 137.916 80.5485 137.958 80.6172C138.304 81.1772 137.6 88.0392 136.393 95.8672C133.906 111.999 134.135 125.756 137.063 136.099C137.576 137.911 138.05 139.95 138.382 141.692Z",
    fill: "url(#paint114_linear_4903_18626)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.005 141.692H193.78C192.243 138.123 189.828 131.577 188.743 126.904C187.223 120.354 185.666 114.994 185.283 114.994C185.252 114.994 185.221 114.996 185.191 115.001C184.593 110.291 184.803 106.199 185.652 101.315C186.696 95.3052 187.376 94.0642 188.809 95.5507C189.212 95.9682 190.634 102.196 191.969 109.391C194.399 122.481 197.814 133.458 202.005 141.692Z",
    fill: "url(#paint115_linear_4903_18626)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M301.529 65.6965C299.593 65.1945 191.195 64.6924 191.195 64.6924C191.195 64.6924 187.807 64.6924 186.839 67.2028C185.871 69.7132 182 125.946 182 128.457C182 130.967 182.968 131.469 185.387 131.469C187.807 131.469 290.399 131.971 293.786 131.469C297.174 130.967 297.174 129.461 297.658 128.457C298.141 127.453 305.884 73.7299 304.916 69.7132C303.949 65.6965 303.465 66.1986 301.529 65.6965Z",
    fill: "url(#paint116_linear_4903_18626)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M305.529 65.6965C303.593 65.1945 195.195 64.6924 195.195 64.6924C195.195 64.6924 191.807 64.6924 190.839 67.2028C189.871 69.7132 186 125.946 186 128.457C186 130.967 186.968 131.469 189.387 131.469C191.807 131.469 294.399 131.971 297.786 131.469C301.174 130.967 301.174 129.461 301.658 128.457C302.141 127.453 309.884 73.7299 308.916 69.7132C307.949 65.6965 307.465 66.1986 305.529 65.6965Z",
    fill: "url(#paint117_linear_4903_18626)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294.5 65.4156V131.583C289.216 131.671 278.239 131.698 265.291 131.692L216.841 64.8042C240.18 64.9336 276.413 65.1616 294.5 65.4156Z",
    fill: "url(#paint118_linear_4903_18626)",
    fillOpacity: 0.75
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 137.192,
    width: 30,
    height: 4,
    fill: "url(#paint119_linear_4903_18626)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M241.5 141.692L237 111.692H261L268.5 141.692H241.5Z",
    fill: "url(#paint120_linear_4903_18626)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M234.5 126.692L237 111.692L241.5 141.192H235L234.5 126.692Z",
    fill: "url(#paint121_linear_4903_18626)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M472.5 86.6924L392 95.6924V291.192H468L472.5 86.6924Z",
    fill: "url(#paint122_linear_4903_18626)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M586.5 88.6924L472.5 86.6924L468 291.192L569.5 291.692L586.5 88.6924Z",
    fill: "url(#paint123_linear_4903_18626)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M511.382 67.4424C511.081 68.4044 510.195 70.3864 509.414 71.8464C507.166 76.0434 507.629 81.1074 510.581 84.6154C513.112 87.6234 513.368 87.6924 521.992 87.6924C530.616 87.6924 530.872 87.6234 533.403 84.6154C536.355 81.1074 536.818 76.0434 534.57 71.8464C533.789 70.3864 532.903 68.4044 532.602 67.4424C532.128 65.9284 530.701 65.6924 521.992 65.6924C513.283 65.6924 511.856 65.9284 511.382 67.4424Z",
    fill: "#33193B"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M511.382 67.4424C511.081 68.4044 510.195 70.3864 509.414 71.8464C507.166 76.0434 507.629 81.1074 510.581 84.6154C513.112 87.6234 513.368 87.6924 521.992 87.6924C530.616 87.6924 530.872 87.6234 533.403 84.6154C536.355 81.1074 536.818 76.0434 534.57 71.8464C533.789 70.3864 532.903 68.4044 532.602 67.4424C532.128 65.9284 530.701 65.6924 521.992 65.6924C513.283 65.6924 511.856 65.9284 511.382 67.4424Z",
    fill: "url(#paint124_linear_4903_18626)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M577 95.1924L480 94.1924V137.192L574 138.192L577 95.1924Z",
    fill: "#DE5D59"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M577 97.1924L480 96.1924V139.192L574 140.192L577 97.1924Z",
    fill: "url(#paint125_linear_4903_18626)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M493.537 78.4878C493.401 78.9251 492.998 79.826 492.643 80.4897C491.621 82.3974 491.831 84.6992 493.173 86.2937C494.324 87.661 494.44 87.6924 498.36 87.6924C502.28 87.6924 502.396 87.661 503.547 86.2937C504.889 84.6992 505.099 82.3974 504.077 80.4897C503.722 79.826 503.32 78.9251 503.183 78.4878C502.967 77.7997 502.319 77.6924 498.36 77.6924C494.401 77.6924 493.753 77.7997 493.537 78.4878Z",
    fill: "#33193B"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M493.537 78.4878C493.401 78.9251 492.998 79.826 492.643 80.4897C491.621 82.3974 491.831 84.6992 493.173 86.2937C494.324 87.661 494.44 87.6924 498.36 87.6924C502.28 87.6924 502.396 87.661 503.547 86.2937C504.889 84.6992 505.099 82.3974 504.077 80.4897C503.722 79.826 503.32 78.9251 503.183 78.4878C502.967 77.7997 502.319 77.6924 498.36 77.6924C494.401 77.6924 493.753 77.7997 493.537 78.4878Z",
    fill: "url(#paint126_linear_4903_18626)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M573 145.692L480 144.692V187.692L570 188.692L573 145.692Z",
    fill: "#DE5D59"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M573 147.692L480 146.692V189.692L570 190.692L573 147.692Z",
    fill: "url(#paint127_linear_4903_18626)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M569 195.692L480 194.692V237.692L566 238.692L569 195.692Z",
    fill: "#DE5D59"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M566 240.692L480 239.692V282.692L563.101 283.692L566 240.692Z",
    fill: "url(#paint128_linear_4903_18626)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M569 197.692L480 196.692V239.692L566 240.692L569 197.692Z",
    fill: "url(#paint129_linear_4903_18626)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M493 41.7588C493 42.3428 492.213 42.7418 491.25 42.6438C485.699 42.0788 484.091 44.4258 489.074 45.8188C491.313 46.4438 491.263 46.5038 488.417 46.5958C484.631 46.7188 483.653 47.5728 485.186 49.4198C486.151 50.5828 485.851 50.7718 483.462 50.5118C481.353 50.2808 480.474 50.6688 480.212 51.9458C479.944 53.2518 480.506 53.6958 482.427 53.6958C484.047 53.6958 485 54.2508 485 55.1958C485 56.0208 485.675 56.6958 486.5 56.6958C487.537 56.6958 488 55.6538 488 53.3178C488 51.4608 488.675 49.3808 489.5 48.6958C490.753 47.6558 491 47.7998 491 49.5738C491 52.4868 492.622 52.2348 496.653 48.6958C499.891 45.8528 502 44.9218 502 46.3358C502 46.6878 501.256 47.5188 500.347 48.1838C499.438 48.8488 499.015 49.9108 499.406 50.5438C500.531 52.3638 503.752 51.8878 505.303 49.6738C506.213 48.3738 507.322 47.8818 508.403 48.2968C509.979 48.9018 509.98 49.0608 508.407 50.7988C506.889 52.4758 506.88 52.7128 508.316 53.2638C509.19 53.5988 510.286 53.6368 510.752 53.3488C511.218 53.0608 512.108 53.6388 512.728 54.6328C513.666 56.1328 513.468 56.6168 511.567 57.4828C510.308 58.0568 509.045 59.4148 508.762 60.4998C508.302 62.2578 508.645 62.4188 511.915 61.9808C515.076 61.5568 515.739 61.8268 516.698 63.9318C517.486 65.6608 518.497 66.3008 520.156 66.1188C521.445 65.9778 522.886 65.8248 523.358 65.7788C523.831 65.7338 523.939 64.5888 523.599 63.2358C523.137 61.3918 523.49 60.5038 525.012 59.6898C527.738 58.2308 529.297 59.2728 528.003 61.6908C527.451 62.7208 527.018 64.3818 527.04 65.3798C527.07 66.7188 527.484 66.4508 528.617 64.3598C530.038 61.7388 530.285 61.6438 531.905 63.1098C532.869 63.9828 534.649 64.6958 535.86 64.6958C538.315 64.6958 539.815 62.1108 538.261 60.5568C536.426 58.7218 539.157 54.7128 542.247 54.7038C544.389 54.6978 545.31 55.4118 546.427 57.9458C547.792 61.0398 547.893 61.0878 548.547 58.9458C549.393 56.1738 550.029 56.1418 552.811 58.7348C555.148 60.9118 555.651 63.2058 553.975 64.0378C553.411 64.3168 553.524 64.4318 554.225 64.2928C556.663 63.8078 556.193 59.9928 553.427 57.8168C551.284 56.1318 550.981 55.4228 551.921 54.2908C553.682 52.1688 551.388 51.2148 548.706 52.9538C545.237 55.2038 543.605 54.0138 545.994 50.9758C548.601 47.6628 548.53 46.4818 545.75 46.8758C544.364 47.0728 542.924 48.4348 542 50.4238C540.131 54.4478 537.812 54.7668 538.212 50.9458C538.44 48.7668 538.085 48.1958 536.5 48.1958C535.062 48.1958 534.411 48.9678 534.184 50.9458C533.824 54.0748 533.687 54.1418 531.042 52.4898C529.466 51.5058 528.766 51.5978 527.227 52.9898C524.975 55.0288 524 55.1528 524 53.4028C524 52.6918 525.462 51.6788 527.248 51.1528C531.049 50.0328 532.24 46.8328 529.156 46.0268C528.046 45.7358 527.358 44.9268 527.626 44.2288C528.271 42.5468 523.984 41.4648 522.28 42.8788C521.186 43.7858 521.221 44.3838 522.477 46.3018C524.523 49.4228 524.511 51.3648 522.458 49.6608C521.374 48.7608 520.601 48.6948 519.858 49.4378C518.54 50.7558 519.691 54.6958 521.394 54.6958C522.225 54.6958 522.504 55.7178 522.213 57.6958C521.971 59.3458 521.411 60.6958 520.968 60.6958C520.526 60.6958 519.339 60.9968 518.332 61.3658C516.582 62.0048 516.578 61.9458 518.25 60.0368C521.546 56.2728 519.597 52.7658 515.977 55.9458C515.194 56.6338 515.329 56.2608 516.277 55.1168C519.561 51.1558 517.905 47.6328 513.771 49.7848L511.5 50.9668L513.75 48.5168C517.86 44.0408 515.728 41.7238 511.314 45.8698C509.02 48.0258 509 48.0268 509 45.9928C509 44.8638 508.35 43.4008 507.555 42.7418C505.86 41.3348 501.411 41.7608 501.694 43.3028C502.054 45.2618 496.184 44.5078 495.667 42.5288C495.158 40.5838 493 39.9608 493 41.7588ZM481.25 55.3578C480.563 55.6358 480 57.2748 480 59.0018C480 61.9378 480.086 62.0128 481.334 60.1688C484.275 55.8188 484.246 54.1488 481.25 55.3578ZM493 63.2268C493 64.0698 493.675 65.0178 494.5 65.3338C496.703 66.1798 496.328 68.6958 494 68.6958C490.962 68.6958 491.376 72.5008 494.5 73.2848C495.875 73.6298 497 74.3138 497 74.8038C497 76.1688 494.607 75.8658 492.441 74.2278C489.943 72.3378 488 72.3028 488 74.1458C488 74.9438 487.216 76.0348 486.258 76.5708C483.105 78.3358 485.852 78.9938 489.38 77.3198C491.764 76.1888 492.889 77.0964 494.5 77.6924C495.784 78.1674 497.855 78.3724 498.492 78.1474C499.129 77.9224 499.643 77.6134 500 78.1924C500.981 79.7794 504 78.9068 504 77.1958C504 76.3708 503.55 75.6958 503 75.6958C501.145 75.6958 501.982 73.9338 504.101 73.3798C505.256 73.0778 505.917 72.3698 505.569 71.8068C505.221 71.2438 504.275 71.0368 503.468 71.3468C501.189 72.2208 501.739 70.1228 504.25 68.3618C506.172 67.0138 506.282 66.6358 505 65.7658C503.874 65.0018 503.409 65.1678 503.137 66.4308C502.635 68.7528 499.959 72.6958 498.885 72.6958C497.669 72.6958 497.764 68.9598 499 68.1958C500.501 67.2678 500.214 64.3998 498.678 64.9888C497.951 65.2678 496.822 64.6408 496.17 63.5958C494.742 61.3098 493 61.1068 493 63.2268ZM505 81.2128C505 81.9368 505.563 82.7558 506.25 83.0338C506.938 83.3108 506.514 83.5738 505.309 83.6168C504.104 83.6598 502.816 84.1848 502.446 84.7828C501.312 86.6188 503.902 88.1958 508.051 88.1958C511.899 88.1958 513.26 87.3028 510.75 86.4248C509.845 86.1088 510.01 85.4128 511.348 83.9048C512.364 82.7588 512.928 81.3888 512.601 80.8588C511.673 79.3578 505 79.6688 505 81.2128ZM534 86.2788C534 88.0448 536.153 87.7378 536.771 85.8838C536.989 85.2298 536.454 84.6958 535.583 84.6958C534.712 84.6958 534 85.4078 534 86.2788Z",
    fill: "#576040"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M493 41.7588C493 42.3428 492.213 42.7418 491.25 42.6438C485.699 42.0788 484.091 44.4258 489.074 45.8188C491.313 46.4438 491.263 46.5038 488.417 46.5958C484.631 46.7188 483.653 47.5728 485.186 49.4198C486.151 50.5828 485.851 50.7718 483.462 50.5118C481.353 50.2808 480.474 50.6688 480.212 51.9458C479.944 53.2518 480.506 53.6958 482.427 53.6958C484.047 53.6958 485 54.2508 485 55.1958C485 56.0208 485.675 56.6958 486.5 56.6958C487.537 56.6958 488 55.6538 488 53.3178C488 51.4608 488.675 49.3808 489.5 48.6958C490.753 47.6558 491 47.7998 491 49.5738C491 52.4868 492.622 52.2348 496.653 48.6958C499.891 45.8528 502 44.9218 502 46.3358C502 46.6878 501.256 47.5188 500.347 48.1838C499.438 48.8488 499.015 49.9108 499.406 50.5438C500.531 52.3638 503.752 51.8878 505.303 49.6738C506.213 48.3738 507.322 47.8818 508.403 48.2968C509.979 48.9018 509.98 49.0608 508.407 50.7988C506.889 52.4758 506.88 52.7128 508.316 53.2638C509.19 53.5988 510.286 53.6368 510.752 53.3488C511.218 53.0608 512.108 53.6388 512.728 54.6328C513.666 56.1328 513.468 56.6168 511.567 57.4828C510.308 58.0568 509.045 59.4148 508.762 60.4998C508.302 62.2578 508.645 62.4188 511.915 61.9808C515.076 61.5568 515.739 61.8268 516.698 63.9318C517.486 65.6608 518.497 66.3008 520.156 66.1188C521.445 65.9778 522.886 65.8248 523.358 65.7788C523.831 65.7338 523.939 64.5888 523.599 63.2358C523.137 61.3918 523.49 60.5038 525.012 59.6898C527.738 58.2308 529.297 59.2728 528.003 61.6908C527.451 62.7208 527.018 64.3818 527.04 65.3798C527.07 66.7188 527.484 66.4508 528.617 64.3598C530.038 61.7388 530.285 61.6438 531.905 63.1098C532.869 63.9828 534.649 64.6958 535.86 64.6958C538.315 64.6958 539.815 62.1108 538.261 60.5568C536.426 58.7218 539.157 54.7128 542.247 54.7038C544.389 54.6978 545.31 55.4118 546.427 57.9458C547.792 61.0398 547.893 61.0878 548.547 58.9458C549.393 56.1738 550.029 56.1418 552.811 58.7348C555.148 60.9118 555.651 63.2058 553.975 64.0378C553.411 64.3168 553.524 64.4318 554.225 64.2928C556.663 63.8078 556.193 59.9928 553.427 57.8168C551.284 56.1318 550.981 55.4228 551.921 54.2908C553.682 52.1688 551.388 51.2148 548.706 52.9538C545.237 55.2038 543.605 54.0138 545.994 50.9758C548.601 47.6628 548.53 46.4818 545.75 46.8758C544.364 47.0728 542.924 48.4348 542 50.4238C540.131 54.4478 537.812 54.7668 538.212 50.9458C538.44 48.7668 538.085 48.1958 536.5 48.1958C535.062 48.1958 534.411 48.9678 534.184 50.9458C533.824 54.0748 533.687 54.1418 531.042 52.4898C529.466 51.5058 528.766 51.5978 527.227 52.9898C524.975 55.0288 524 55.1528 524 53.4028C524 52.6918 525.462 51.6788 527.248 51.1528C531.049 50.0328 532.24 46.8328 529.156 46.0268C528.046 45.7358 527.358 44.9268 527.626 44.2288C528.271 42.5468 523.984 41.4648 522.28 42.8788C521.186 43.7858 521.221 44.3838 522.477 46.3018C524.523 49.4228 524.511 51.3648 522.458 49.6608C521.374 48.7608 520.601 48.6948 519.858 49.4378C518.54 50.7558 519.691 54.6958 521.394 54.6958C522.225 54.6958 522.504 55.7178 522.213 57.6958C521.971 59.3458 521.411 60.6958 520.968 60.6958C520.526 60.6958 519.339 60.9968 518.332 61.3658C516.582 62.0048 516.578 61.9458 518.25 60.0368C521.546 56.2728 519.597 52.7658 515.977 55.9458C515.194 56.6338 515.329 56.2608 516.277 55.1168C519.561 51.1558 517.905 47.6328 513.771 49.7848L511.5 50.9668L513.75 48.5168C517.86 44.0408 515.728 41.7238 511.314 45.8698C509.02 48.0258 509 48.0268 509 45.9928C509 44.8638 508.35 43.4008 507.555 42.7418C505.86 41.3348 501.411 41.7608 501.694 43.3028C502.054 45.2618 496.184 44.5078 495.667 42.5288C495.158 40.5838 493 39.9608 493 41.7588ZM481.25 55.3578C480.563 55.6358 480 57.2748 480 59.0018C480 61.9378 480.086 62.0128 481.334 60.1688C484.275 55.8188 484.246 54.1488 481.25 55.3578ZM493 63.2268C493 64.0698 493.675 65.0178 494.5 65.3338C496.703 66.1798 496.328 68.6958 494 68.6958C490.962 68.6958 491.376 72.5008 494.5 73.2848C495.875 73.6298 497 74.3138 497 74.8038C497 76.1688 494.607 75.8658 492.441 74.2278C489.943 72.3378 488 72.3028 488 74.1458C488 74.9438 487.216 76.0348 486.258 76.5708C483.105 78.3358 485.852 78.9938 489.38 77.3198C491.764 76.1888 492.889 77.0964 494.5 77.6924C495.784 78.1674 497.855 78.3724 498.492 78.1474C499.129 77.9224 499.643 77.6134 500 78.1924C500.981 79.7794 504 78.9068 504 77.1958C504 76.3708 503.55 75.6958 503 75.6958C501.145 75.6958 501.982 73.9338 504.101 73.3798C505.256 73.0778 505.917 72.3698 505.569 71.8068C505.221 71.2438 504.275 71.0368 503.468 71.3468C501.189 72.2208 501.739 70.1228 504.25 68.3618C506.172 67.0138 506.282 66.6358 505 65.7658C503.874 65.0018 503.409 65.1678 503.137 66.4308C502.635 68.7528 499.959 72.6958 498.885 72.6958C497.669 72.6958 497.764 68.9598 499 68.1958C500.501 67.2678 500.214 64.3998 498.678 64.9888C497.951 65.2678 496.822 64.6408 496.17 63.5958C494.742 61.3098 493 61.1068 493 63.2268ZM505 81.2128C505 81.9368 505.563 82.7558 506.25 83.0338C506.938 83.3108 506.514 83.5738 505.309 83.6168C504.104 83.6598 502.816 84.1848 502.446 84.7828C501.312 86.6188 503.902 88.1958 508.051 88.1958C511.899 88.1958 513.26 87.3028 510.75 86.4248C509.845 86.1088 510.01 85.4128 511.348 83.9048C512.364 82.7588 512.928 81.3888 512.601 80.8588C511.673 79.3578 505 79.6688 505 81.2128ZM534 86.2788C534 88.0448 536.153 87.7378 536.771 85.8838C536.989 85.2298 536.454 84.6958 535.583 84.6958C534.712 84.6958 534 85.4078 534 86.2788Z",
    fill: "url(#paint130_linear_4903_18626)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M496 104.692C496 104.14 496.448 103.692 497 103.692H502C502.552 103.692 503 104.14 503 104.692V136.692H496V104.692Z",
    fill: "url(#paint131_linear_4903_18626)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M505 138.692H494V104.692C494 103.036 495.343 101.692 497 101.692H502C503.657 101.692 505 103.036 505 104.692V138.692ZM497 103.692C496.448 103.692 496 104.14 496 104.692V136.692H503V104.692C503 104.14 502.552 103.692 502 103.692H497Z",
    fill: "url(#paint132_linear_4903_18626)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M497 103.692H498V136.692H497V103.692Z",
    fill: "url(#paint133_linear_4903_18626)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M499 103.692H500V136.692H499V103.692Z",
    fill: "url(#paint134_linear_4903_18626)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M501 103.692H502V136.692H501V103.692Z",
    fill: "url(#paint135_linear_4903_18626)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M507 104.692C507 104.14 507.448 103.692 508 103.692H513C513.552 103.692 514 104.14 514 104.692V136.692H507V104.692Z",
    fill: "url(#paint136_linear_4903_18626)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M516 138.692H505V104.692C505 103.036 506.343 101.692 508 101.692H513C514.657 101.692 516 103.036 516 104.692V138.692ZM508 103.692C507.448 103.692 507 104.14 507 104.692V136.692H514V104.692C514 104.14 513.552 103.692 513 103.692H508Z",
    fill: "url(#paint137_linear_4903_18626)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M508 103.692H509V136.692H508V103.692Z",
    fill: "url(#paint138_linear_4903_18626)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M510 103.692H511V136.692H510V103.692Z",
    fill: "url(#paint139_linear_4903_18626)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M512 103.692H513V136.692H512V103.692Z",
    fill: "url(#paint140_linear_4903_18626)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M482 155.692C482 155.14 482.448 154.692 483 154.692H488C488.552 154.692 489 155.14 489 155.692V187.692H482V155.692Z",
    fill: "url(#paint141_linear_4903_18626)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M491 189.692H480V155.692C480 154.036 481.343 152.692 483 152.692H488C489.657 152.692 491 154.036 491 155.692V189.692ZM483 154.692C482.448 154.692 482 155.14 482 155.692V187.692H489V155.692C489 155.14 488.552 154.692 488 154.692H483Z",
    fill: "url(#paint142_linear_4903_18626)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M483 154.692H484V187.692H483V154.692Z",
    fill: "url(#paint143_linear_4903_18626)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M485 154.692H486V187.692H485V154.692Z",
    fill: "url(#paint144_linear_4903_18626)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M487 154.692H488V187.692H487V154.692Z",
    fill: "url(#paint145_linear_4903_18626)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M493 155.692C493 155.14 493.448 154.692 494 154.692H499C499.552 154.692 500 155.14 500 155.692V187.692H493V155.692Z",
    fill: "url(#paint146_linear_4903_18626)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502 189.692H491V155.692C491 154.036 492.343 152.692 494 152.692H499C500.657 152.692 502 154.036 502 155.692V189.692ZM494 154.692C493.448 154.692 493 155.14 493 155.692V187.692H500V155.692C500 155.14 499.552 154.692 499 154.692H494Z",
    fill: "url(#paint147_linear_4903_18626)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M494 154.692H495V187.692H494V154.692Z",
    fill: "url(#paint148_linear_4903_18626)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M496 154.692H497V187.692H496V154.692Z",
    fill: "url(#paint149_linear_4903_18626)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M498 154.692H499V187.692H498V154.692Z",
    fill: "url(#paint150_linear_4903_18626)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M504 155.692C504 155.14 504.448 154.692 505 154.692H510C510.552 154.692 511 155.14 511 155.692V187.692H504V155.692Z",
    fill: "url(#paint151_linear_4903_18626)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M513 189.692H502V155.692C502 154.036 503.343 152.692 505 152.692H510C511.657 152.692 513 154.036 513 155.692V189.692ZM505 154.692C504.448 154.692 504 155.14 504 155.692V187.692H511V155.692C511 155.14 510.552 154.692 510 154.692H505Z",
    fill: "url(#paint152_linear_4903_18626)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M505 154.692H506V187.692H505V154.692Z",
    fill: "url(#paint153_linear_4903_18626)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M507 154.692H508V187.692H507V154.692Z",
    fill: "url(#paint154_linear_4903_18626)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M509 154.692H510V187.692H509V154.692Z",
    fill: "url(#paint155_linear_4903_18626)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M547 187.692C547.552 187.692 548 187.245 548 186.692L548 181.692C548 181.14 547.552 180.692 547 180.692L515 180.692L515 187.692L547 187.692Z",
    fill: "url(#paint156_linear_4903_18626)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M513 178.692L513 189.692L547 189.692C548.657 189.692 550 188.349 550 186.692L550 181.692C550 180.036 548.657 178.692 547 178.692L513 178.692ZM548 186.692C548 187.245 547.552 187.692 547 187.692L515 187.692L515 180.692L547 180.692C547.552 180.692 548 181.14 548 181.692L548 186.692Z",
    fill: "url(#paint157_linear_4903_18626)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M548 186.692L548 185.692L515 185.692L515 186.692L548 186.692Z",
    fill: "url(#paint158_linear_4903_18626)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M548 184.692L548 183.692L515 183.692L515 184.692L548 184.692Z",
    fill: "url(#paint159_linear_4903_18626)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M548 182.692L548 181.692L515 181.692L515 182.692L548 182.692Z",
    fill: "url(#paint160_linear_4903_18626)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M514 237.692C514.552 237.692 515 237.245 515 236.692L515 231.692C515 231.14 514.552 230.692 514 230.692L482 230.692L482 237.692L514 237.692Z",
    fill: "url(#paint161_linear_4903_18626)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M480 228.692L480 239.692L514 239.692C515.657 239.692 517 238.349 517 236.692L517 231.692C517 230.036 515.657 228.692 514 228.692L480 228.692ZM515 236.692C515 237.245 514.552 237.692 514 237.692L482 237.692L482 230.692L514 230.692C514.552 230.692 515 231.14 515 231.692L515 236.692Z",
    fill: "url(#paint162_linear_4903_18626)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M515 236.692L515 235.692L482 235.692L482 236.692L515 236.692Z",
    fill: "url(#paint163_linear_4903_18626)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M515 234.692L515 233.692L482 233.692L482 234.692L515 234.692Z",
    fill: "url(#paint164_linear_4903_18626)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M515 232.692L515 231.692L482 231.692L482 232.692L515 232.692Z",
    fill: "url(#paint165_linear_4903_18626)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M527.062 205.735C527.05 205.183 526.593 204.745 526.041 204.757L521.042 204.864C520.49 204.876 520.052 205.333 520.064 205.886L520.753 237.878L527.752 237.727L527.062 205.735Z",
    fill: "url(#paint166_linear_4903_18626)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M518.797 239.921L529.794 239.684L529.062 205.692C529.026 204.035 527.654 202.721 525.998 202.757L520.999 202.865C519.342 202.9 518.029 204.272 518.064 205.929L518.797 239.921ZM526.041 204.757C526.593 204.745 527.05 205.183 527.062 205.735L527.752 237.727L520.753 237.878L520.064 205.886C520.052 205.333 520.49 204.876 521.042 204.864L526.041 204.757Z",
    fill: "url(#paint167_linear_4903_18626)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M526.041 204.757L525.041 204.778L525.752 237.77L526.752 237.749L526.041 204.757Z",
    fill: "url(#paint168_linear_4903_18626)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M524.041 204.8L523.042 204.821L523.753 237.814L524.752 237.792L524.041 204.8Z",
    fill: "url(#paint169_linear_4903_18626)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M522.042 204.843L521.042 204.864L521.753 237.857L522.753 237.835L522.042 204.843Z",
    fill: "url(#paint170_linear_4903_18626)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M539.062 205.735C539.05 205.183 538.593 204.745 538.041 204.757L533.042 204.864C532.49 204.876 532.052 205.333 532.064 205.886L532.753 237.878L539.752 237.727L539.062 205.735Z",
    fill: "url(#paint171_linear_4903_18626)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M530.797 239.921L541.794 239.684L541.062 205.692C541.026 204.035 539.654 202.721 537.998 202.757L532.999 202.865C531.342 202.9 530.029 204.272 530.064 205.929L530.797 239.921ZM538.041 204.757C538.593 204.745 539.05 205.183 539.062 205.735L539.752 237.727L532.753 237.878L532.064 205.886C532.052 205.333 532.49 204.876 533.042 204.864L538.041 204.757Z",
    fill: "url(#paint172_linear_4903_18626)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M538.041 204.757L537.041 204.778L537.752 237.77L538.752 237.749L538.041 204.757Z",
    fill: "url(#paint173_linear_4903_18626)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M536.041 204.8L535.042 204.821L535.753 237.814L536.752 237.792L536.041 204.8Z",
    fill: "url(#paint174_linear_4903_18626)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M534.042 204.843L533.042 204.864L533.753 237.857L534.753 237.835L534.042 204.843Z",
    fill: "url(#paint175_linear_4903_18626)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M547.294 206.29C547.018 205.812 546.407 205.648 545.928 205.924L541.598 208.424C541.12 208.701 540.956 209.312 541.232 209.79L557.232 237.503L563.294 234.003L547.294 206.29Z",
    fill: "url(#paint176_linear_4903_18626)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M556.5 240.235L566.026 234.735L549.026 205.29C548.198 203.856 546.363 203.364 544.928 204.192L540.598 206.692C539.163 207.521 538.672 209.356 539.5 210.79L556.5 240.235ZM545.928 205.924C546.407 205.648 547.018 205.812 547.294 206.29L563.294 234.003L557.232 237.503L541.232 209.79C540.956 209.312 541.12 208.701 541.598 208.424L545.928 205.924Z",
    fill: "url(#paint177_linear_4903_18626)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M545.928 205.924L545.062 206.424L561.562 235.003L562.428 234.503L545.928 205.924Z",
    fill: "url(#paint178_linear_4903_18626)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M544.196 206.924L543.33 207.424L559.83 236.003L560.696 235.503L544.196 206.924Z",
    fill: "url(#paint179_linear_4903_18626)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M542.464 207.924L541.598 208.424L558.098 237.003L558.964 236.503L542.464 207.924Z",
    fill: "url(#paint180_linear_4903_18626)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M540.605 108.252C540.981 107.847 541.614 107.824 542.018 108.199L545.682 111.602C546.086 111.978 546.11 112.611 545.734 113.016L523.955 136.461L518.826 131.697L540.605 108.252Z",
    fill: "url(#paint181_linear_4903_18626)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M524.059 139.287L516 131.801L539.14 106.89C540.268 105.676 542.166 105.607 543.38 106.734L547.043 110.137C548.257 111.265 548.327 113.163 547.199 114.377L524.059 139.287ZM542.018 108.199C541.614 107.824 540.981 107.847 540.605 108.252L518.826 131.697L523.955 136.461L545.734 113.016C546.11 112.611 546.086 111.978 545.682 111.602L542.018 108.199Z",
    fill: "url(#paint182_linear_4903_18626)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M542.018 108.199L542.751 108.88L520.292 133.058L519.559 132.377L542.018 108.199Z",
    fill: "url(#paint183_linear_4903_18626)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M543.484 109.561L544.216 110.241L521.757 134.419L521.024 133.739L543.484 109.561Z",
    fill: "url(#paint184_linear_4903_18626)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M544.949 110.922L545.682 111.602L523.222 135.78L522.49 135.1L544.949 110.922Z",
    fill: "url(#paint185_linear_4903_18626)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M551 105.692C551 105.14 551.448 104.692 552 104.692H557C557.552 104.692 558 105.14 558 105.692V137.692H551V105.692Z",
    fill: "url(#paint186_linear_4903_18626)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560 139.692H549V105.692C549 104.036 550.343 102.692 552 102.692H557C558.657 102.692 560 104.036 560 105.692V139.692ZM552 104.692C551.448 104.692 551 105.14 551 105.692V137.692H558V105.692C558 105.14 557.552 104.692 557 104.692H552Z",
    fill: "url(#paint187_linear_4903_18626)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M552 104.692H553V137.692H552V104.692Z",
    fill: "url(#paint188_linear_4903_18626)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M554 104.692H555V137.692H554V104.692Z",
    fill: "url(#paint189_linear_4903_18626)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M556 104.692H557V137.692H556V104.692Z",
    fill: "url(#paint190_linear_4903_18626)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M429 137.692H388C388 137.692 390.47 139.244 392.94 139.554C395.41 139.865 422.084 139.554 424.06 139.554C426.036 139.554 429 137.692 429 137.692Z",
    fill: "url(#paint191_linear_4903_18626)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M425 139.692H384C384 139.692 386.47 141.244 388.94 141.554C391.41 141.865 418.084 141.554 420.06 141.554C422.036 141.554 425 139.692 425 139.692Z",
    fill: "url(#paint192_linear_4903_18626)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M433 138.692H388C388 138.692 390.711 140.244 393.422 140.554C396.133 140.865 425.41 140.554 427.578 140.554C429.747 140.554 433 138.692 433 138.692Z",
    fill: "url(#paint193_linear_4903_18626)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M433 138.692H388C388 138.692 390.711 139.08 393.422 139.158C396.133 139.235 425.41 139.158 427.578 139.158C429.747 139.158 433 138.692 433 138.692Z",
    fill: "url(#paint194_linear_4903_18626)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M435 139.692H387C387 139.692 389.892 141.244 392.783 141.554C395.675 141.865 426.904 141.554 429.217 141.554C431.53 141.554 435 139.692 435 139.692Z",
    fill: "url(#paint195_linear_4903_18626)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M433 139.692H388C388 139.692 390.711 140.08 393.422 140.158C396.133 140.235 425.41 140.158 427.578 140.158C429.747 140.158 433 139.692 433 139.692Z",
    fill: "url(#paint196_linear_4903_18626)"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 279.692,
    width: 336,
    height: 12,
    fill: "url(#paint197_linear_4903_18626)"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 280.692,
    width: 334,
    height: 10,
    stroke: "url(#paint198_linear_4903_18626)",
    strokeOpacity: 0.2,
    strokeWidth: 2
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 10,
    transform: "matrix(-1 0 0 1 87 281.692)",
    fill: "url(#paint199_linear_4903_18626)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M440.5 150.192L429.5 282.192L85.5 282.692L79 150.192H440.5Z",
    fill: "url(#paint200_linear_4903_18626)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2162 139.147C97.44 139.147 96.8108 138.577 96.8108 137.874L96.8108 131.511C96.8108 130.808 97.44 130.238 98.2162 130.238L146 130.238L146 139.147L98.2162 139.147Z",
    fill: "url(#paint201_linear_4903_18626)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146 127.692L146 141.692L98.2162 141.692C95.8877 141.692 94 139.983 94 137.874L94 131.511C94 129.402 95.8877 127.692 98.2162 127.692L146 127.692ZM96.8108 137.874C96.8108 138.577 97.44 139.147 98.2162 139.147L146 139.147L146 130.238L98.2162 130.238C97.44 130.238 96.8108 130.808 96.8108 131.511L96.8108 137.874Z",
    fill: "url(#paint202_linear_4903_18626)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8108 137.874L96.8108 136.601L146.189 136.601L146.189 137.874L96.8108 137.874Z",
    fill: "url(#paint203_linear_4903_18626)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8108 135.329L96.8108 134.056L146.189 134.056L146.189 135.329L96.8108 135.329Z",
    fill: "url(#paint204_linear_4903_18626)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8108 132.783L96.8108 131.511L146.189 131.511L146.189 132.783L96.8108 132.783Z",
    fill: "url(#paint205_linear_4903_18626)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M439.667 160.192L440.5 150.192H79L79.4906 160.192H439.667Z",
    fill: "url(#paint206_linear_4903_18626)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M452.5 141.192H77.5V153.192H451L452.5 141.192Z",
    fill: "url(#paint207_linear_4903_18626)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5 141.192H77.5V153.192H79.492L79.5 141.192Z",
    fill: "url(#paint208_linear_4903_18626)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M451 141.192H449V153.192H450.992L451 141.192Z",
    fill: "url(#paint209_linear_4903_18626)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5 153.192V141.192L0 142.192L2 153.192H77.5Z",
    fill: "url(#paint210_linear_4903_18626)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5 282.692L80 153.192H10L23.5 282.692H86.5Z",
    fill: "url(#paint211_linear_4903_18626)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M332.5 132.692L327.5 141.192H376.5L371 132.692H332.5Z",
    fill: "url(#paint212_linear_4903_18626)"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 78.7812,
    y: 100.21,
    width: 3.76877,
    height: 30.1379,
    transform: "rotate(-12.7287 78.7812 100.21)",
    fill: "#FCFCFC"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 78.4723,
    y: 98.8445,
    width: 3.76877,
    height: 10.5617,
    transform: "rotate(-12.7287 78.4723 98.8445)",
    fill: "#885E95"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 78.7327,
    y: 99.9855,
    width: 3.76877,
    height: 28.4752,
    transform: "rotate(-12.7287 78.7327 99.9855)",
    fill: "#1F1628"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 79.9584,
    y: 99.7087,
    width: 1.25626,
    height: 28.4752,
    transform: "rotate(-12.7287 79.9584 99.7087)",
    fill: "#361C40"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 81.1837,
    y: 99.432,
    width: 1.25626,
    height: 28.4752,
    transform: "rotate(-12.7287 81.1837 99.432)",
    fill: "#573661"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_4903_18626",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 85,
    y: 127,
    width: 5,
    height: 7
  }, _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0217 132.254C86.1745 132.931 86.8471 133.355 87.5238 133.202L88.7492 132.926C89.426 132.773 89.8507 132.1 89.6978 131.423L88.8674 127.747L85.1913 128.578L86.0217 132.254Z",
    fill: "#F15642"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_4903_18626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.4169 128.301L87.6422 128.024L88.7494 132.926L87.524 133.203L86.4169 128.301Z",
    fill: "#DC695A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1915 128.578L86.4169 128.301L87.524 133.203L86.2987 133.479L85.1915 128.578Z",
    fill: "#B56B61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6422 128.024L88.8676 127.748L89.9748 132.649L88.7494 132.926L87.6422 128.024Z",
    fill: "#ED8173"
  }))), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1848 95.1471C79.256 94.792 79.7139 94.6886 79.9307 94.9786L82.0721 97.8423C82.2538 98.0852 82.1249 98.4347 81.8291 98.5015L78.9851 99.1439C78.6892 99.2108 78.4226 98.9506 78.4822 98.6532L79.1848 95.1471Z",
    fill: "#EDAFA1"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.4095 95.6167C80.2387 95.7817 80.0203 95.9052 79.7632 95.9633C79.5058 96.0214 79.2552 96.0036 79.0299 95.9278L79.1863 95.147C79.2575 94.7919 79.7154 94.6884 79.9323 94.9785L80.4095 95.6167Z",
    fill: "#56575B"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 85.9673,
    y: 105.708,
    width: 3.76877,
    height: 30.1379,
    transform: "rotate(-4.33878 85.9673 105.708)",
    fill: "#FCFCFC"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 85.861,
    y: 104.313,
    width: 3.76877,
    height: 10.5617,
    transform: "rotate(-4.33878 85.861 104.313)",
    fill: "#B4454C"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 85.9521,
    y: 105.48,
    width: 3.76877,
    height: 28.4752,
    transform: "rotate(-4.33878 85.9521 105.48)",
    fill: "#802E33"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 87.2051,
    y: 105.385,
    width: 1.25626,
    height: 28.4752,
    transform: "rotate(-4.33878 87.2051 105.385)",
    fill: "#C44B46"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 88.4576,
    y: 105.29,
    width: 1.25626,
    height: 28.4752,
    transform: "rotate(-4.33878 88.4576 105.29)",
    fill: "#DE5D59"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_4903_18626",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 88,
    y: 134,
    width: 5,
    height: 6
  }, _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4548 138.466C88.5073 139.158 89.1107 139.676 89.8025 139.624L91.0552 139.529C91.747 139.476 92.2653 138.873 92.2128 138.181L91.9277 134.423L88.1697 134.708L88.4548 138.466Z",
    fill: "#F15642"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_4903_18626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.4225 134.613L90.6751 134.518L91.0553 139.529L89.8026 139.624L89.4225 134.613Z",
    fill: "#DC695A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1698 134.708L89.4225 134.613L89.8026 139.624L88.55 139.719L88.1698 134.708Z",
    fill: "#B56B61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6751 134.518L91.9278 134.423L92.3079 139.434L91.0553 139.529L90.6751 134.518Z",
    fill: "#ED8173"
  }))), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1053 100.759C87.2275 100.418 87.6956 100.382 87.8679 100.701L89.5685 103.847C89.7128 104.113 89.5343 104.44 89.2318 104.463L86.3246 104.684C86.0221 104.707 85.7963 104.41 85.8987 104.125L87.1053 100.759Z",
    fill: "#EDAFA1"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.2484 101.402C88.0553 101.54 87.8213 101.631 87.5585 101.651C87.2953 101.671 87.05 101.617 86.8381 101.509L87.1068 100.759C87.2291 100.418 87.6971 100.383 87.8694 100.701L88.2484 101.402Z",
    fill: "#56575B"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 97.8168,
    y: 113.342,
    width: 3.76877,
    height: 23.8764,
    transform: "rotate(11.2888 97.8168 113.342)",
    fill: "#FCFCFC"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 98.0333,
    y: 112.255,
    width: 3.76877,
    height: 8.36734,
    transform: "rotate(11.2888 98.0333 112.255)",
    fill: "#B4454C"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 97.8543,
    y: 113.164,
    width: 3.76877,
    height: 22.5591,
    transform: "rotate(11.2888 97.8543 113.164)",
    fill: "#802E33"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 99.0867,
    y: 113.41,
    width: 1.25626,
    height: 22.5591,
    transform: "rotate(11.2888 99.0867 113.41)",
    fill: "#C44B46"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 100.318,
    y: 113.656,
    width: 1.25626,
    height: 22.5591,
    transform: "rotate(11.2888 100.318 113.656)",
    fill: "#DE5D59"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_4903_18626",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 92,
    y: 135,
    width: 6,
    height: 6
  }, _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7748 138.61C92.639 139.29 93.0805 139.952 93.7609 140.088L94.9928 140.333C95.6732 140.469 96.3349 140.028 96.4707 139.347L97.0041 136.675L93.3082 135.938L92.7748 138.61Z",
    fill: "#F15642"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_4903_18626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.5399 136.184L95.7719 136.43L94.9926 140.334L93.7606 140.088L94.5399 136.184Z",
    fill: "#DC695A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.308 135.938L94.5399 136.184L93.7606 140.088L92.5287 139.842L93.308 135.938Z",
    fill: "#B56B61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7719 136.43L97.0038 136.676L96.2245 140.58L94.9926 140.334L95.7719 136.43Z",
    fill: "#ED8173"
  }))), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M100.072 109.843C100.285 109.596 100.686 109.676 100.787 109.986L101.666 112.67C101.765 112.975 101.5 113.274 101.186 113.211L98.466 112.668C98.1518 112.605 98.0215 112.227 98.2305 111.985L100.072 109.843Z",
    fill: "#EDAFA1"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.988 110.597C100.776 110.684 100.535 110.713 100.282 110.663C100.029 110.612 99.8169 110.492 99.6547 110.33L100.073 109.843C100.286 109.596 100.687 109.676 100.789 109.986L100.988 110.597Z",
    fill: "#56575B"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 96.0715,
    y: 102.671,
    width: 3.76877,
    height: 26.154,
    transform: "rotate(4.91691 96.0715 102.671)",
    fill: "#FCFCFC"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 96.1758,
    y: 101.461,
    width: 3.76877,
    height: 9.16552,
    transform: "rotate(4.91691 96.1758 101.461)",
    fill: "#885E95"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 96.0914,
    y: 102.474,
    width: 3.76877,
    height: 24.7111,
    transform: "rotate(4.91691 96.0914 102.474)",
    fill: "#1F1628"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 97.3434,
    y: 102.581,
    width: 1.25626,
    height: 24.7111,
    transform: "rotate(4.91691 97.3434 102.581)",
    fill: "#361C40"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 98.5944,
    y: 102.689,
    width: 1.25626,
    height: 24.7111,
    transform: "rotate(4.91691 98.5944 102.689)",
    fill: "#573661"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_4903_18626",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 93,
    y: 127,
    width: 5,
    height: 6
  }, _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6445 130.911C93.585 131.602 94.0972 132.21 94.7884 132.27L96.0401 132.378C96.7313 132.437 97.3399 131.925 97.3994 131.234L97.6655 128.14L93.9106 127.817L93.6445 130.911Z",
    fill: "#F15642"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_4903_18626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.1622 127.925L96.4138 128.033L96.04 132.378L94.7884 132.27L95.1622 127.925Z",
    fill: "#DC695A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9105 127.818L95.1622 127.925L94.7884 132.27L93.5368 132.162L93.9105 127.818Z",
    fill: "#B56B61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4138 128.033L97.6654 128.141L97.2917 132.486L96.04 132.378L96.4138 128.033Z",
    fill: "#ED8173"
  }))), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9477 98.5897C98.129 98.3013 98.5604 98.3384 98.6897 98.6535L99.8654 101.519C99.9844 101.809 99.7544 102.122 99.4421 102.095L96.6186 101.852C96.3063 101.825 96.1332 101.478 96.2999 101.212L97.9477 98.5897Z",
    fill: "#EDAFA1"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.9568 99.2996C98.7509 99.4079 98.5103 99.462 98.2513 99.4397C97.9917 99.4174 97.7636 99.3227 97.579 99.1803L97.9499 98.59C98.1311 98.3016 98.5626 98.3387 98.6919 98.6539L98.9568 99.2996Z",
    fill: "#56575B"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.158 119.87C77.419 121.796 79.44 137.147 80.757 139.607C81.735 141.434 82.671 141.6 90.531 141.339L99.223 141.051L100.38 137.512C101.016 135.566 101.692 130.616 101.882 126.512L102.227 119.051C97.6309 118.941 95.0541 118.879 90.458 118.769C81.167 118.547 78.577 118.778 78.158 119.87Z",
    fill: "url(#paint213_linear_4903_18626)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M156.521 33.4982C156.494 33.4945 156.457 33.4896 156.411 33.4836C156.309 33.4706 156.164 33.4526 155.985 33.4327C155.627 33.393 155.134 33.3453 154.592 33.3134C154.051 33.2815 153.454 33.2651 152.892 33.2895C152.338 33.3136 151.783 33.3786 151.342 33.5257C151.072 33.6157 150.772 33.757 150.462 33.926C150.716 33.7369 150.971 33.5734 151.224 33.4472C152.148 32.9853 153.331 32.7438 154.312 32.6211C154.797 32.5605 155.222 32.5301 155.525 32.515C155.676 32.5074 155.797 32.5037 155.879 32.5018C155.919 32.5009 155.951 32.5004 155.971 32.5002L155.994 32.5L155.999 32.5L156.006 32.5001C156.013 32.5003 156.025 32.5006 156.041 32.5014C156.073 32.5029 156.121 32.5061 156.179 32.5126C156.298 32.5258 156.449 32.5516 156.592 32.5993C156.902 32.7026 157 32.8321 157 33C157 33.1625 156.961 33.2511 156.928 33.3008C156.893 33.3535 156.842 33.3949 156.776 33.4278C156.709 33.4616 156.635 33.481 156.574 33.4912C156.553 33.4947 156.535 33.4969 156.521 33.4982Z",
    stroke: "#311739"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M169.746 33.495C169.76 33.4925 169.777 33.4896 169.795 33.4865C169.874 33.4732 169.986 33.4551 170.124 33.4349C170.4 33.3947 170.781 33.3463 171.2 33.314C171.617 33.2817 172.082 33.2647 172.523 33.2899C172.955 33.3145 173.405 33.3816 173.772 33.5419C173.839 33.5714 173.908 33.6058 173.979 33.6443C173.878 33.5593 173.778 33.4833 173.678 33.418C173.002 32.9742 172.13 32.7389 171.395 32.6184C171.033 32.559 170.717 32.5294 170.491 32.5146C170.379 32.5072 170.289 32.5035 170.229 32.5017C170.199 32.5008 170.176 32.5004 170.162 32.5002L170.146 32.5L170.145 32.5C170.141 32.5001 170.135 32.5004 170.125 32.501C170.105 32.5022 170.075 32.5048 170.036 32.5104C169.958 32.5219 169.861 32.5439 169.772 32.5831C169.683 32.6221 169.618 32.6703 169.576 32.7249C169.54 32.773 169.5 32.8524 169.5 33C169.5 33.351 169.621 33.4346 169.655 33.457C169.686 33.477 169.718 33.4887 169.746 33.495Z",
    stroke: "#311739"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.006 39.6782C158.006 37.8775 157.115 36.9951 157.115 36.9951L153.55 36.707L151.524 37.0671L149.499 38.1476L148.121 38.6519C148.121 38.6519 147.879 40.7587 148.284 41.8391C148.689 42.9195 149.499 43.2797 149.499 43.2797C149.499 43.2797 150.714 44 152.335 44C153.955 44 153.955 44 155.17 43.6398C156.385 43.2797 157.196 42.1992 157.196 42.1992C157.196 42.1992 158.006 41.2629 158.006 39.6782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.006 39.6782C158.006 37.8775 157.115 36.9951 157.115 36.9951L153.55 36.707L151.524 37.0671L149.499 38.1476L148.121 38.6519C148.121 38.6519 147.879 40.7587 148.284 41.8391C148.689 42.9195 149.499 43.2797 149.499 43.2797C149.499 43.2797 150.714 44 152.335 44C153.955 44 153.955 44 155.17 43.6398C156.385 43.2797 157.196 42.1992 157.196 42.1992C157.196 42.1992 158.006 41.2629 158.006 39.6782Z",
    fill: "url(#paint214_linear_4903_18626)"
  }))), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M155.826 36.797C154.661 36.7746 152.89 36.8792 151.697 37.082C151.596 37.0992 151.489 37.1223 151.377 37.1507C151.427 37.1334 151.477 37.1172 151.527 37.1022C153.222 36.5898 154.84 36.6958 155.826 36.797Z",
    stroke: "#311739",
    strokeWidth: 0.905163
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M154.658 37.205C153.916 37.2183 153.117 37.2565 152.412 37.319C153.209 37.2058 153.981 37.1856 154.658 37.205Z",
    stroke: "#311739",
    strokeWidth: 0.905163
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.149 43.9969C154.842 43.915 156.195 42.1337 156.195 39.9482C156.195 38.6931 155.749 37.5713 155.048 36.8281L153.55 36.707L151.524 37.0671L150.412 37.6607C150.063 38.3117 149.859 39.0995 149.859 39.9482C149.859 42.155 151.238 43.9498 152.955 43.9988C153.023 43.9984 153.088 43.9978 153.149 43.9969Z",
    fill: "#311739"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M156 40.4191C156 42.3968 154.657 44 153 44C151.344 44 150 42.3968 150 40.4191C150 38.4414 151.344 36.8381 153 36.8381C154.657 36.8381 156 38.4414 156 40.4191Z",
    fill: "url(#paint215_linear_4903_18626)"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4903_18626)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-202-inside-1_4903_18626",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.702 42.0593C152.207 42.0061 151 41.3437 151 41.3437C151 41.3437 151.997 42.2795 152.706 42.474C153.414 42.6685 154.261 42.4043 154.261 42.4043C154.261 42.4043 154.561 41.9659 154.539 41.9015C154.517 41.8371 153.841 42.0717 153.841 42.0717C153.841 42.0717 153.198 42.1125 152.702 42.0593Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M151 41.3437L150.306 42.0243L151.471 40.5012L151 41.3437ZM152.702 42.0593L152.643 43.0314L152.643 43.0314L152.702 42.0593ZM153.841 42.0717L154.234 42.9937L154.103 43.0389L153.963 43.0478L153.841 42.0717ZM154.539 41.9015L153.57 42.1594L153.57 42.1594L154.539 41.9015ZM154.261 42.4043L155.123 42.9715L154.941 43.2368L154.624 43.336L154.261 42.4043ZM152.706 42.474L152.474 43.4134L152.474 43.4134L152.706 42.474ZM151 41.3437C151.471 40.5012 151.471 40.5011 151.471 40.5011C151.471 40.5011 151.471 40.5011 151.471 40.5011C151.471 40.501 151.471 40.501 151.471 40.501C151.471 40.501 151.471 40.501 151.471 40.5011C151.471 40.5012 151.471 40.5015 151.472 40.5019C151.474 40.5027 151.476 40.5042 151.48 40.5062C151.488 40.5102 151.499 40.5165 151.514 40.5246C151.545 40.541 151.59 40.5649 151.646 40.5941C151.758 40.6527 151.912 40.7305 152.078 40.8091C152.246 40.8886 152.414 40.9631 152.56 41.0184C152.728 41.0824 152.786 41.0897 152.762 41.0872L152.643 43.0314C152.372 43.0023 152.093 42.9068 151.895 42.8317C151.675 42.7478 151.449 42.6467 151.253 42.554C151.055 42.4603 150.876 42.3693 150.747 42.302C150.682 42.2682 150.629 42.24 150.591 42.2199C150.572 42.2098 150.558 42.2018 150.547 42.1961C150.542 42.1932 150.538 42.191 150.535 42.1893C150.533 42.1885 150.532 42.1878 150.531 42.1873C150.53 42.187 150.53 42.1868 150.53 42.1866C150.53 42.1865 150.529 42.1864 150.529 42.1864C150.529 42.1863 150.529 42.1863 150.529 42.1863C150.529 42.1862 150.529 42.1862 151 41.3437ZM152.762 41.0872C152.944 41.1068 153.178 41.1106 153.386 41.1073C153.485 41.1057 153.571 41.1026 153.631 41.1C153.661 41.0986 153.685 41.0974 153.7 41.0966C153.707 41.0962 153.713 41.0959 153.716 41.0957C153.718 41.0956 153.719 41.0955 153.719 41.0955C153.72 41.0955 153.72 41.0955 153.72 41.0955C153.72 41.0955 153.72 41.0955 153.719 41.0955C153.719 41.0955 153.719 41.0955 153.719 41.0955C153.719 41.0955 153.719 41.0955 153.719 41.0955C153.719 41.0955 153.719 41.0955 153.841 42.0717C153.963 43.0478 153.963 43.0478 153.963 43.0479C153.963 43.0479 153.963 43.0479 153.963 43.0479C153.962 43.0479 153.962 43.0479 153.962 43.0479C153.962 43.0479 153.962 43.0479 153.961 43.0479C153.961 43.048 153.96 43.048 153.959 43.0481C153.957 43.0482 153.954 43.0484 153.951 43.0486C153.945 43.0489 153.936 43.0494 153.925 43.05C153.903 43.0512 153.872 43.0528 153.834 43.0545C153.758 43.0578 153.653 43.0616 153.529 43.0636C153.292 43.0674 152.956 43.0651 152.643 43.0314L152.762 41.0872ZM153.841 42.0717C153.448 41.1497 153.448 41.1496 153.448 41.1496C153.448 41.1496 153.449 41.1496 153.449 41.1496C153.449 41.1496 153.449 41.1495 153.449 41.1495C153.449 41.1494 153.449 41.1493 153.45 41.1492C153.45 41.149 153.451 41.1488 153.452 41.1485C153.454 41.1479 153.456 41.147 153.459 41.146C153.465 41.1439 153.473 41.1411 153.484 41.1375C153.505 41.1304 153.534 41.1205 153.569 41.109C153.639 41.0861 153.735 41.0553 153.835 41.0259C153.927 40.9986 154.051 40.9642 154.166 40.9418C154.215 40.9323 154.317 40.9136 154.435 40.9121C154.486 40.9115 154.62 40.9118 154.78 40.9591C154.926 41.0023 155.346 41.1668 155.508 41.6436L153.57 42.1594C153.606 42.2636 153.658 42.3608 153.724 42.4476C153.79 42.5335 153.863 42.6014 153.933 42.6539C154.068 42.7552 154.197 42.8032 154.276 42.8264C154.358 42.8506 154.426 42.8599 154.468 42.864C154.512 42.8683 154.547 42.8688 154.571 42.8685C154.616 42.868 154.648 42.864 154.658 42.8627C154.671 42.861 154.677 42.8597 154.675 42.8601C154.658 42.8635 154.608 42.8757 154.529 42.899C154.457 42.9202 154.383 42.944 154.325 42.9631C154.296 42.9725 154.272 42.9805 154.256 42.9859C154.248 42.9887 154.242 42.9908 154.238 42.9921C154.236 42.9928 154.235 42.9933 154.234 42.9935C154.234 42.9937 154.233 42.9938 154.233 42.9938C154.233 42.9938 154.233 42.9938 154.233 42.9938C154.233 42.9938 154.233 42.9938 154.233 42.9938C154.233 42.9938 154.233 42.9937 154.234 42.9937C154.234 42.9937 154.234 42.9937 153.841 42.0717ZM155.508 41.6436C155.584 41.8645 155.56 42.0469 155.551 42.1054C155.539 42.1857 155.52 42.2498 155.507 42.287C155.482 42.3627 155.451 42.4278 155.43 42.468C155.388 42.5536 155.336 42.641 155.295 42.7069C155.252 42.7769 155.209 42.8424 155.178 42.8893C155.163 42.9131 155.149 42.933 155.14 42.9471C155.135 42.9542 155.131 42.9599 155.128 42.964C155.127 42.9661 155.126 42.9678 155.125 42.969C155.125 42.9696 155.124 42.9702 155.124 42.9706C155.124 42.9708 155.124 42.971 155.124 42.9711C155.124 42.9712 155.123 42.9713 155.123 42.9713C155.123 42.9714 155.123 42.9714 155.123 42.9714C155.123 42.9715 155.123 42.9715 154.261 42.4043C153.398 41.837 153.398 41.8371 153.398 41.8371C153.398 41.8371 153.398 41.8371 153.398 41.8372C153.398 41.8372 153.398 41.8372 153.398 41.8372C153.398 41.8373 153.398 41.8373 153.398 41.8373C153.398 41.8373 153.398 41.8372 153.398 41.837C153.398 41.8366 153.399 41.8358 153.4 41.8346C153.401 41.8323 153.404 41.8285 153.407 41.8235C153.414 41.8134 153.424 41.7985 153.436 41.7802C153.461 41.7429 153.492 41.6948 153.521 41.6471C153.553 41.5954 153.572 41.5611 153.58 41.5464C153.584 41.5365 153.573 41.5567 153.56 41.5962C153.554 41.6152 153.538 41.6633 153.528 41.73C153.523 41.7646 153.518 41.817 153.519 41.8818C153.521 41.9442 153.53 42.043 153.57 42.1594L155.508 41.6436ZM154.261 42.4043C154.624 43.336 154.623 43.3361 154.623 43.3362C154.623 43.3362 154.623 43.3363 154.623 43.3363C154.622 43.3364 154.622 43.3365 154.622 43.3366C154.621 43.3368 154.62 43.337 154.62 43.3373C154.618 43.3378 154.616 43.3383 154.614 43.3389C154.61 43.3401 154.606 43.3415 154.6 43.3432C154.589 43.3465 154.574 43.3508 154.557 43.3557C154.521 43.3655 154.474 43.3782 154.415 43.3922C154.3 43.42 154.138 43.454 153.949 43.4804C153.59 43.5302 153.035 43.5674 152.474 43.4134L152.938 41.5346C153.085 41.5751 153.307 41.5774 153.549 41.5438C153.659 41.5284 153.754 41.5085 153.819 41.4928C153.851 41.4851 153.875 41.4787 153.889 41.4748C153.896 41.4729 153.9 41.4716 153.902 41.4712C153.903 41.4709 153.903 41.4709 153.902 41.4711C153.902 41.4712 153.901 41.4714 153.9 41.4716C153.9 41.4718 153.9 41.4719 153.899 41.472C153.899 41.4721 153.899 41.4722 153.898 41.4722C153.898 41.4723 153.898 41.4724 153.898 41.4724C153.898 41.4724 153.898 41.4725 154.261 42.4043ZM152.474 43.4134C151.893 43.254 151.317 42.8479 150.977 42.5878C150.785 42.4414 150.621 42.3032 150.504 42.2018C150.445 42.1508 150.397 42.1082 150.364 42.0777C150.347 42.0624 150.333 42.05 150.324 42.041C150.319 42.0364 150.315 42.0328 150.312 42.03C150.31 42.0286 150.309 42.0274 150.308 42.0265C150.307 42.026 150.307 42.0256 150.307 42.0252C150.306 42.025 150.306 42.0249 150.306 42.0247C150.306 42.0246 150.306 42.0245 150.306 42.0245C150.306 42.0244 150.306 42.0243 151 41.3437C151.694 40.6631 151.694 40.663 151.694 40.6629C151.694 40.6629 151.694 40.6628 151.694 40.6628C151.694 40.6627 151.694 40.6626 151.694 40.6625C151.693 40.6624 151.693 40.6623 151.693 40.6623C151.693 40.6622 151.693 40.6624 151.694 40.6628C151.695 40.6636 151.696 40.6652 151.699 40.6675C151.704 40.6723 151.713 40.6802 151.725 40.6909C151.748 40.7123 151.784 40.7444 151.83 40.7841C151.922 40.8642 152.051 40.9721 152.197 41.084C152.533 41.3405 152.81 41.4995 152.938 41.5346L152.474 43.4134Z",
    fill: "#AB67BF",
    mask: "url(#path-202-inside-1_4903_18626)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 155,
    cy: 39,
    r: 1,
    fill: "white"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.001 39.6782C168.001 37.8775 168.738 36.9951 168.738 36.9951L171.688 36.707L173.363 37.0672L175.039 38.1476L176.179 38.6519C176.179 38.6519 176.38 40.7587 176.045 41.8391C175.71 42.9196 175.039 43.2797 175.039 43.2797C175.039 43.2797 174.034 44 172.693 44C171.353 44 171.352 44 170.347 43.6399C169.342 43.2797 168.671 42.1993 168.671 42.1993C168.671 42.1993 168.001 41.2629 168.001 39.6782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.001 39.6782C168.001 37.8775 168.738 36.9951 168.738 36.9951L171.688 36.707L173.363 37.0672L175.039 38.1476L176.179 38.6519C176.179 38.6519 176.38 40.7587 176.045 41.8391C175.71 42.9196 175.039 43.2797 175.039 43.2797C175.039 43.2797 174.034 44 172.693 44C171.353 44 171.352 44 170.347 43.6399C169.342 43.2797 168.671 42.1993 168.671 42.1993C168.671 42.1993 168.001 41.2629 168.001 39.6782Z",
    fill: "url(#paint216_linear_4903_18626)"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-206-inside-2_4903_18626",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.138 37.5013C174.356 37.6924 177.001 39.2728 177.001 39.2728C177.001 39.2728 175.644 37.4258 173.973 36.9048C172.303 36.3838 170.179 36.3898 169.413 36.5287C168.647 36.6677 168.397 37.7235 168.397 37.7235C168.397 37.7235 168.443 37.5832 169.21 37.4443C169.976 37.3053 171.919 37.3103 173.138 37.5013Z"
  }))), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M177.001 39.2728L177.73 38.7317L176.534 40.0523L177.001 39.2728ZM173.138 37.5013L173.284 36.6058L173.138 37.5013ZM173.973 36.9048L174.248 36.0391L173.973 36.9048ZM168.397 37.7235L169.256 38L167.518 37.5211L168.397 37.7235ZM177.001 39.2728C176.534 40.0523 176.534 40.0524 176.534 40.0524C176.534 40.0524 176.534 40.0524 176.534 40.0524C176.534 40.0524 176.534 40.0524 176.534 40.0523C176.534 40.0522 176.533 40.052 176.533 40.0517C176.532 40.0511 176.53 40.0502 176.528 40.0489C176.524 40.0463 176.517 40.0422 176.508 40.0368C176.489 40.0259 176.462 40.0097 176.426 39.9888C176.354 39.9469 176.25 39.8864 176.12 39.813C175.86 39.6658 175.502 39.4682 175.109 39.2656C174.714 39.0622 174.292 38.8583 173.903 38.6959C173.499 38.5273 173.186 38.4274 172.992 38.3969L173.284 36.6058C173.699 36.6708 174.173 36.84 174.608 37.0215C175.058 37.2092 175.526 37.4363 175.944 37.6518C176.364 37.8682 176.744 38.0776 177.018 38.2328C177.155 38.3105 177.266 38.375 177.344 38.4203C177.383 38.4429 177.413 38.4608 177.434 38.4732C177.445 38.4794 177.453 38.4843 177.459 38.4876C177.461 38.4893 177.464 38.4907 177.465 38.4916C177.466 38.4921 177.467 38.4924 177.467 38.4927C177.467 38.4929 177.468 38.493 177.468 38.4931C177.468 38.4931 177.468 38.4932 177.468 38.4932C177.468 38.4932 177.468 38.4933 177.001 39.2728ZM172.992 38.3969C172.441 38.3105 171.697 38.2629 170.988 38.2554C170.265 38.2478 169.659 38.2827 169.364 38.3362L169.055 36.5524C169.527 36.4669 170.275 36.4348 171.02 36.4427C171.779 36.4507 172.616 36.5011 173.284 36.6058L172.992 38.3969ZM169.259 35.6368C169.739 35.5497 170.54 35.516 171.411 35.5643C172.291 35.613 173.319 35.7494 174.248 36.0391L173.699 37.7705C172.957 37.5392 172.088 37.4181 171.297 37.3743C170.497 37.33 169.853 37.3688 169.567 37.4206L169.259 35.6368ZM174.248 36.0391C175.28 36.361 176.157 37.0658 176.742 37.6277C177.043 37.9169 177.286 38.1876 177.454 38.3869C177.539 38.4869 177.605 38.5698 177.652 38.6292C177.675 38.659 177.693 38.6829 177.707 38.7002C177.713 38.7089 177.718 38.7159 177.722 38.7212C177.724 38.7239 177.726 38.7261 177.727 38.7278C177.728 38.7287 177.729 38.7295 177.729 38.7301C177.729 38.7305 177.729 38.7308 177.73 38.731C177.73 38.7312 177.73 38.7313 177.73 38.7314C177.73 38.7316 177.73 38.7317 177.001 39.2728C176.272 39.8139 176.272 39.814 176.272 39.8142C176.272 39.8142 176.272 39.8143 176.272 39.8144C176.272 39.8146 176.272 39.8147 176.272 39.8148C176.273 39.815 176.273 39.8151 176.273 39.8151C176.273 39.8151 176.272 39.8146 176.272 39.8138C176.27 39.812 176.268 39.8086 176.264 39.8036C176.256 39.7937 176.244 39.7774 176.227 39.7556C176.193 39.712 176.14 39.6466 176.072 39.5652C175.934 39.402 175.733 39.1783 175.486 38.9407C174.974 38.4489 174.338 37.9696 173.699 37.7705L174.248 36.0391ZM169.567 37.4206C169.567 37.4207 169.567 37.4207 169.567 37.4207C169.567 37.4207 169.567 37.4206 169.567 37.4206C169.567 37.4206 169.567 37.4206 169.567 37.4206C169.567 37.4206 169.567 37.4206 169.567 37.4207C169.567 37.4207 169.567 37.4208 169.567 37.4209C169.566 37.421 169.566 37.4214 169.565 37.4219C169.56 37.4241 169.55 37.4304 169.533 37.4452C169.497 37.4779 169.452 37.5348 169.405 37.6186C169.359 37.7001 169.324 37.7843 169.301 37.8502C169.29 37.882 169.283 37.9067 169.279 37.921C169.277 37.928 169.276 37.9323 169.275 37.9333C169.275 37.9338 169.275 37.9335 169.276 37.9323C169.276 37.9317 169.276 37.9308 169.276 37.9298C169.276 37.9293 169.276 37.9287 169.277 37.928C169.277 37.9277 169.277 37.9274 169.277 37.927C169.277 37.9268 169.277 37.9266 169.277 37.9265C169.277 37.9262 169.277 37.9259 168.397 37.7235C167.518 37.5211 167.518 37.5208 167.518 37.5205C167.518 37.5204 167.518 37.5201 167.518 37.5199C167.518 37.5194 167.518 37.519 167.519 37.5186C167.519 37.5177 167.519 37.5167 167.519 37.5157C167.52 37.5136 167.52 37.5112 167.521 37.5086C167.522 37.5034 167.524 37.4972 167.526 37.4899C167.529 37.4754 167.534 37.4568 167.541 37.4347C167.553 37.3907 167.571 37.3318 167.596 37.2625C167.643 37.126 167.719 36.9376 167.831 36.7378C168.037 36.3705 168.475 35.7788 169.259 35.6368L169.567 37.4206ZM168.397 37.7235C167.539 37.447 167.539 37.445 167.54 37.443C167.54 37.4424 167.541 37.4404 167.541 37.4391C167.542 37.4365 167.543 37.4339 167.544 37.4313C167.546 37.4261 167.548 37.4209 167.55 37.4157C167.553 37.4053 167.557 37.3951 167.562 37.3849C167.57 37.3646 167.579 37.3447 167.588 37.3253C167.608 37.2864 167.629 37.2499 167.652 37.2158C167.697 37.1476 167.749 37.0897 167.8 37.0408C167.902 36.9455 168.015 36.8756 168.125 36.8218C168.34 36.7169 168.635 36.6286 169.055 36.5524L169.364 38.3362C169.018 38.3989 168.907 38.4502 168.907 38.4501C168.91 38.4488 168.964 38.4227 169.033 38.358C169.068 38.3245 169.11 38.2786 169.15 38.2186C169.17 38.1886 169.19 38.1552 169.208 38.1185C169.217 38.1001 169.226 38.0811 169.234 38.0613C169.238 38.0514 169.242 38.0413 169.245 38.0311C169.247 38.026 169.249 38.0208 169.251 38.0156C169.252 38.0131 169.253 38.0105 169.254 38.0078C169.254 38.0065 169.255 38.0046 169.255 38.0039C169.256 38.002 169.256 38 168.397 37.7235Z",
    fill: "#311739",
    mask: "url(#path-206-inside-2_4903_18626)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M170.865 37.2042C171.381 37.217 171.926 37.2471 172.428 37.294C171.877 37.2116 171.345 37.1924 170.865 37.2042Z",
    stroke: "#311739",
    strokeWidth: 0.905163
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.022 43.997C170.62 43.9169 169.5 42.1348 169.5 39.9481C169.5 38.6931 169.869 37.5713 170.449 36.8281L171.688 36.707L173.364 37.0672L174.285 37.661C174.573 38.3119 174.742 39.0995 174.742 39.9481C174.742 42.1561 173.6 43.9516 172.178 43.9988C172.124 43.9984 172.072 43.9978 172.022 43.997Z",
    fill: "#311739"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M169.66 40.4193C169.66 42.397 170.771 44.0002 172.142 44.0002C173.513 44.0002 174.624 42.397 174.624 40.4193C174.624 38.4416 173.513 36.8384 172.142 36.8384C170.771 36.8384 169.66 38.4416 169.66 40.4193Z",
    fill: "url(#paint217_linear_4903_18626)"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_4903_18626)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-211-inside-3_4903_18626",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.389 42.0591C172.799 42.0059 173.798 41.3435 173.798 41.3435C173.798 41.3435 172.972 42.2793 172.386 42.4738C171.8 42.6683 171.1 42.4041 171.1 42.4041C171.1 42.4041 170.851 41.9656 170.869 41.9013C170.887 41.8369 171.447 42.0715 171.447 42.0715C171.447 42.0715 171.979 42.1123 172.389 42.0591Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M173.798 41.3435L174.537 42.042L173.243 40.4835L173.798 41.3435ZM172.389 42.0591L172.549 43.0664L172.549 43.0664L172.389 42.0591ZM171.447 42.0715L171.107 43.0099L171.254 43.0717L171.411 43.0838L171.447 42.0715ZM171.1 42.4041L170.255 42.8912L170.443 43.2239L170.793 43.3558L171.1 42.4041ZM172.386 42.4738L172.72 43.4413L172.72 43.4413L172.386 42.4738ZM173.798 41.3435C173.243 40.4835 173.243 40.4835 173.243 40.4834C173.243 40.4834 173.243 40.4834 173.243 40.4834C173.243 40.4833 173.243 40.4833 173.243 40.4833C173.243 40.4833 173.243 40.4833 173.243 40.4834C173.243 40.4835 173.242 40.4837 173.242 40.4842C173.24 40.485 173.238 40.4864 173.235 40.4884C173.229 40.4924 173.22 40.4985 173.207 40.5067C173.182 40.5229 173.145 40.5467 173.099 40.5757C173.006 40.634 172.88 40.7114 172.744 40.7893C172.606 40.8684 172.469 40.9415 172.352 40.9951C172.211 41.06 172.181 41.058 172.229 41.0518L172.549 43.0664C172.802 43.0335 173.05 42.9289 173.211 42.8546C173.397 42.769 173.587 42.6665 173.75 42.5734C173.915 42.479 174.064 42.3875 174.171 42.3199C174.225 42.286 174.269 42.2576 174.3 42.2374C174.316 42.2273 174.328 42.2192 174.337 42.2135C174.342 42.2106 174.345 42.2083 174.348 42.2066C174.349 42.2058 174.35 42.2051 174.351 42.2046C174.351 42.2043 174.351 42.2041 174.352 42.2039C174.352 42.2038 174.352 42.2037 174.352 42.2036C174.352 42.2036 174.352 42.2036 174.352 42.2035C174.352 42.2035 174.352 42.2035 173.798 41.3435ZM172.229 41.0518C172.093 41.0695 171.912 41.0735 171.745 41.0703C171.666 41.0687 171.597 41.0658 171.55 41.0632C171.526 41.0619 171.508 41.0608 171.496 41.06C171.49 41.0597 171.486 41.0594 171.484 41.0592C171.482 41.0591 171.482 41.0591 171.482 41.0591C171.481 41.059 171.482 41.059 171.482 41.0591C171.482 41.0591 171.482 41.0591 171.482 41.0591C171.482 41.0591 171.482 41.0591 171.482 41.0591C171.482 41.0591 171.482 41.0591 171.482 41.0591C171.482 41.0591 171.482 41.0591 171.447 42.0715C171.411 43.0838 171.412 43.0838 171.412 43.0838C171.412 43.0838 171.412 43.0838 171.412 43.0838C171.412 43.0838 171.412 43.0839 171.412 43.0839C171.412 43.0839 171.413 43.0839 171.413 43.0839C171.414 43.084 171.414 43.084 171.415 43.0841C171.417 43.0842 171.42 43.0844 171.422 43.0846C171.428 43.085 171.436 43.0856 171.445 43.0862C171.464 43.0875 171.491 43.0891 171.523 43.0908C171.588 43.0943 171.679 43.0982 171.784 43.1002C171.985 43.1041 172.275 43.1019 172.549 43.0664L172.229 41.0518ZM171.447 42.0715C171.787 41.1331 171.787 41.1331 171.787 41.133C171.787 41.133 171.787 41.133 171.787 41.133C171.787 41.133 171.787 41.1329 171.787 41.1329C171.787 41.1328 171.786 41.1327 171.786 41.1326C171.786 41.1323 171.785 41.1321 171.784 41.1317C171.783 41.131 171.78 41.1301 171.778 41.129C171.772 41.1268 171.765 41.1238 171.756 41.1201C171.738 41.1127 171.713 41.1025 171.683 41.0905C171.624 41.067 171.541 41.0348 171.454 41.0039C171.375 40.9759 171.261 40.9373 171.151 40.9114C171.105 40.9006 170.999 40.8769 170.876 40.875C170.82 40.8742 170.683 40.8755 170.525 40.9318C170.359 40.991 170.041 41.1649 169.923 41.5836L171.815 42.219C171.762 42.4092 171.658 42.5607 171.539 42.6693C171.426 42.7716 171.312 42.825 171.232 42.8533C171.152 42.882 171.083 42.8938 171.037 42.8992C170.989 42.9048 170.95 42.9056 170.923 42.9052C170.87 42.9044 170.832 42.8988 170.816 42.8963C170.798 42.8934 170.786 42.8907 170.783 42.89C170.783 42.89 170.813 42.898 170.876 42.9205C170.931 42.9402 170.989 42.9627 171.036 42.9812C171.058 42.9902 171.077 42.9977 171.09 43.0029C171.096 43.0055 171.101 43.0074 171.104 43.0086C171.105 43.0092 171.106 43.0097 171.107 43.0099C171.107 43.01 171.107 43.01 171.107 43.01C171.107 43.01 171.107 43.01 171.107 43.01C171.107 43.01 171.107 43.0099 171.107 43.0099C171.107 43.0099 171.107 43.0099 171.107 43.0099C171.107 43.0099 171.107 43.0099 171.447 42.0715ZM169.923 41.5836C169.868 41.7796 169.885 41.9455 169.892 42.0061C169.902 42.0845 169.918 42.1484 169.928 42.1871C169.95 42.2651 169.977 42.3327 169.994 42.3748C170.031 42.464 170.075 42.5542 170.11 42.6213C170.146 42.6927 170.182 42.7595 170.208 42.8072C170.221 42.8314 170.232 42.8515 170.241 42.866C170.245 42.8732 170.248 42.8791 170.25 42.8833C170.251 42.8855 170.252 42.8872 170.253 42.8885C170.254 42.8892 170.254 42.8897 170.254 42.8902C170.254 42.8904 170.254 42.8906 170.254 42.8908C170.255 42.8909 170.255 42.8909 170.255 42.891C170.255 42.891 170.255 42.8911 170.255 42.8911C170.255 42.8912 170.255 42.8912 171.1 42.4041C171.945 41.9169 171.945 41.9169 171.945 41.917C171.945 41.917 171.945 41.917 171.945 41.9171C171.945 41.9171 171.945 41.9171 171.945 41.9172C171.945 41.9172 171.945 41.9173 171.945 41.9173C171.945 41.9173 171.945 41.9172 171.945 41.9171C171.945 41.9167 171.944 41.916 171.944 41.9149C171.942 41.9127 171.94 41.9091 171.938 41.9042C171.932 41.8944 171.924 41.8798 171.914 41.8619C171.894 41.8254 171.869 41.7785 171.846 41.7323C171.82 41.6818 171.806 41.6503 171.801 41.6391C171.798 41.6311 171.808 41.6539 171.819 41.6957C171.825 41.7162 171.838 41.7641 171.846 41.8289C171.851 41.8761 171.869 42.031 171.815 42.219L169.923 41.5836ZM171.1 42.4041C170.793 43.3558 170.793 43.3559 170.793 43.356C170.794 43.356 170.794 43.3561 170.794 43.3562C170.794 43.3563 170.795 43.3564 170.795 43.3566C170.796 43.3569 170.796 43.3571 170.797 43.3575C170.799 43.3581 170.801 43.3587 170.803 43.3595C170.807 43.3609 170.811 43.3627 170.817 43.3646C170.828 43.3685 170.841 43.3732 170.858 43.3787C170.89 43.3896 170.933 43.4035 170.985 43.4187C171.089 43.4487 171.232 43.4852 171.401 43.5136C171.72 43.5673 172.219 43.6077 172.72 43.4413L172.052 41.5063C171.967 41.5344 171.823 41.5399 171.645 41.5101C171.566 41.4967 171.498 41.4793 171.451 41.4659C171.429 41.4594 171.413 41.4541 171.404 41.4513C171.4 41.45 171.398 41.4493 171.399 41.4494C171.399 41.4494 171.4 41.4497 171.401 41.4501C171.401 41.4504 171.402 41.4507 171.403 41.451C171.404 41.4512 171.404 41.4514 171.405 41.4516C171.405 41.4517 171.405 41.4518 171.406 41.4519C171.406 41.452 171.406 41.4521 171.406 41.4521C171.406 41.4522 171.407 41.4523 171.1 42.4041ZM172.72 43.4413C173.225 43.2738 173.709 42.8572 173.984 42.6033C174.142 42.4572 174.278 42.3193 174.375 42.2183C174.423 42.1675 174.462 42.1251 174.49 42.0948C174.504 42.0795 174.515 42.0673 174.523 42.0583C174.527 42.0539 174.53 42.0503 174.533 42.0475C174.534 42.0461 174.535 42.045 174.536 42.0441C174.536 42.0436 174.536 42.0432 174.537 42.0429C174.537 42.0427 174.537 42.0425 174.537 42.0424C174.537 42.0423 174.537 42.0422 174.537 42.0422C174.537 42.0421 174.537 42.042 173.798 41.3435C173.058 40.645 173.058 40.6449 173.058 40.6448C173.058 40.6448 173.058 40.6447 173.058 40.6447C173.058 40.6446 173.058 40.6445 173.058 40.6444C173.058 40.6443 173.058 40.6443 173.058 40.6443C173.058 40.6442 173.058 40.6444 173.058 40.6448C173.057 40.6456 173.056 40.6473 173.053 40.6497C173.049 40.6546 173.042 40.6626 173.032 40.6734C173.012 40.6949 172.982 40.7272 172.944 40.7672C172.868 40.8477 172.761 40.956 172.639 41.0681C172.516 41.1818 172.388 41.29 172.27 41.3756C172.211 41.4179 172.16 41.4504 172.119 41.4737C172.098 41.4851 172.082 41.4933 172.07 41.4988C172.058 41.5044 172.052 41.5064 172.052 41.5063L172.72 43.4413Z",
    fill: "#AB67BF",
    mask: "url(#path-211-inside-3_4903_18626)"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.00587,
    ry: 1,
    transform: "matrix(-1 0 0 1 173.7 39)",
    fill: "white"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-214-inside-4_4903_18626",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166 51H162L164.4 51.5L166 51Z"
  }))), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M162 51V50L161.796 51.979L162 51ZM166 51L166.298 51.9545L166 50V51ZM164.4 51.5L164.196 52.479L164.45 52.532L164.698 52.4545L164.4 51.5ZM162 52H166V50H162V52ZM165.702 50.0455L164.102 50.5455L164.698 52.4545L166.298 51.9545L165.702 50.0455ZM164.604 50.521L162.204 50.021L161.796 51.979L164.196 52.479L164.604 50.521Z",
    fill: "url(#paint218_linear_4903_18626)",
    mask: "url(#path-214-inside-4_4903_18626)"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_4903_18626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.936 51.3566L162.651 50.5H164.793L163.936 51.3566Z",
    stroke: "#B53A32"
  }))), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M339.731 98.2934C338.187 98.8444 337.393 99.5511 336.67 101.021C336.003 102.376 335.985 102.482 336.004 104.888C336.027 107.725 336.442 109.577 337.66 112.284C338.328 113.771 338.427 114.215 338.575 116.42C338.886 121.027 340.441 125.338 343.029 128.771C344.656 130.929 346.479 132.711 346.698 132.357C346.787 132.213 346.931 130.328 347.017 128.168C347.238 122.663 347.89 119.983 349.362 118.53C350.068 117.832 350.179 117.83 351.153 118.505C353.325 120.011 354.448 123.345 354.802 129.338C354.902 131.022 355.031 132.448 355.089 132.506C355.232 132.649 355.994 132.235 356.914 131.514C357.817 130.807 359.118 128.804 359.712 127.208C360.92 123.963 361.177 119.16 360.365 115.008L359.914 112.702L360.556 111.429C363.508 105.582 363.802 101.021 361.349 99.1493C360.576 98.5603 358.633 97.9949 357.4 98C356.471 98.0039 354.576 98.4661 351.898 99.3413L350.11 99.9259L347.987 99.2658C343.939 98.0064 341.38 97.7053 339.731 98.2934Z",
    fill: "#E0D7F1"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M339.731 98.2934C338.187 98.8444 337.393 99.5511 336.67 101.021C336.003 102.376 335.985 102.482 336.004 104.888C336.027 107.725 336.442 109.577 337.66 112.284C338.328 113.771 338.427 114.215 338.575 116.42C338.886 121.027 340.441 125.338 343.029 128.771C344.656 130.929 346.479 132.711 346.698 132.357C346.787 132.213 346.931 130.328 347.017 128.168C347.238 122.663 347.89 119.983 349.362 118.53C350.068 117.832 350.179 117.83 351.153 118.505C353.325 120.011 354.448 123.345 354.802 129.338C354.902 131.022 355.031 132.448 355.089 132.506C355.232 132.649 355.994 132.235 356.914 131.514C357.817 130.807 359.118 128.804 359.712 127.208C360.92 123.963 361.177 119.16 360.365 115.008L359.914 112.702L360.556 111.429C363.508 105.582 363.802 101.021 361.349 99.1493C360.576 98.5603 358.633 97.9949 357.4 98C356.471 98.0039 354.576 98.4661 351.898 99.3413L350.11 99.9259L347.987 99.2658C343.939 98.0064 341.38 97.7053 339.731 98.2934Z",
    fill: "url(#paint219_linear_4903_18626)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M339.731 98.2934C338.187 98.8444 337.393 99.5511 336.67 101.021C336.003 102.376 335.985 102.482 336.004 104.888C336.027 107.725 336.442 109.577 337.66 112.284C338.328 113.771 338.427 114.215 338.575 116.42C338.886 121.027 340.441 125.338 343.029 128.771C344.656 130.929 346.479 132.711 346.698 132.357C346.787 132.213 346.931 130.328 347.017 128.168C347.238 122.663 347.89 119.983 349.362 118.53C350.068 117.832 350.179 117.83 351.153 118.505C353.325 120.011 354.448 123.345 354.802 129.338C354.902 131.022 355.031 132.448 355.089 132.506C355.232 132.649 355.994 132.235 356.914 131.514C357.817 130.807 359.118 128.804 359.712 127.208C360.92 123.963 361.177 119.16 360.365 115.008L359.914 112.702L360.556 111.429C363.508 105.582 363.802 101.021 361.349 99.1493C360.576 98.5603 358.633 97.9949 357.4 98C356.471 98.0039 354.576 98.4661 351.898 99.3413L350.11 99.9259L347.987 99.2658C343.939 98.0064 341.38 97.7053 339.731 98.2934Z",
    fill: "url(#paint220_linear_4903_18626)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.804 100.006C150.551 100.022 150.418 100.039 150.219 100.078C149.567 100.206 148.962 100.511 148.563 100.911C148.365 101.109 148.204 101.341 148.122 101.547C147.953 101.969 147.96 102.357 148.142 102.676C148.215 102.804 148.364 102.962 148.486 103.043C148.701 103.185 148.908 103.268 149.186 103.326C149.338 103.357 149.47 103.368 149.693 103.368C149.967 103.368 150.168 103.345 150.437 103.286L150.509 103.27L150.533 103.213C150.547 103.182 150.587 103.092 150.623 103.014C150.756 102.719 150.772 102.683 150.768 102.677C150.766 102.674 150.738 102.682 150.705 102.695C150.631 102.723 150.479 102.768 150.369 102.792C150.096 102.854 149.795 102.856 149.561 102.796C149.281 102.724 149.073 102.527 149.006 102.269C148.972 102.139 148.975 101.997 149.015 101.816C149.102 101.423 149.38 101.044 149.749 100.818C150.028 100.647 150.295 100.562 150.648 100.532C150.763 100.522 150.797 100.522 150.913 100.532C151.126 100.551 151.283 100.583 151.435 100.64C151.474 100.655 151.51 100.665 151.514 100.663C151.528 100.653 151.771 100.183 151.767 100.171C151.761 100.155 151.611 100.102 151.456 100.063C151.36 100.038 151.255 100.023 151.1 100.01C150.947 99.9973 150.95 99.9974 150.804 100.006ZM155.623 100.069L155.513 100.073L155.466 100.192C155.441 100.257 155.402 100.355 155.381 100.409C155.36 100.463 155.316 100.577 155.283 100.662C155.251 100.747 155.205 100.866 155.181 100.927C155.157 100.988 155.123 101.075 155.106 101.121C155.065 101.227 154.88 101.702 154.855 101.765C154.845 101.791 154.807 101.887 154.772 101.978C154.737 102.069 154.673 102.235 154.63 102.346C154.587 102.457 154.52 102.631 154.48 102.733C154.44 102.835 154.39 102.965 154.367 103.022C154.345 103.078 154.309 103.172 154.286 103.229C154.263 103.287 154.247 103.335 154.249 103.337C154.263 103.345 154.687 103.351 154.877 103.346L155.092 103.34L155.147 103.2C155.177 103.124 155.216 103.022 155.235 102.974C155.349 102.676 155.395 102.559 155.432 102.464C155.471 102.367 155.498 102.298 155.575 102.097C155.59 102.058 155.635 101.94 155.676 101.836C155.717 101.732 155.77 101.595 155.794 101.532C155.818 101.469 155.868 101.34 155.905 101.246C155.943 101.152 155.989 101.033 156.008 100.981C156.044 100.885 156.106 100.726 156.168 100.571C156.186 100.523 156.236 100.397 156.277 100.291C156.317 100.184 156.353 100.091 156.356 100.084C156.361 100.073 156.344 100.071 156.201 100.067C156.03 100.061 155.801 100.062 155.623 100.069ZM164.416 100.417C164.37 100.425 164.194 100.455 164.025 100.484C163.855 100.512 163.698 100.539 163.676 100.544L163.635 100.552L163.586 100.684C163.558 100.757 163.532 100.827 163.527 100.84L163.518 100.864L163.317 100.872L163.117 100.879L163.087 100.962C163.07 101.008 163.038 101.092 163.017 101.149C162.995 101.205 162.977 101.254 162.977 101.256C162.977 101.259 163.064 101.263 163.171 101.267C163.277 101.27 163.365 101.273 163.365 101.274C163.365 101.276 163.309 101.414 163.226 101.618C162.883 102.463 162.845 102.563 162.819 102.67C162.786 102.807 162.798 102.971 162.845 103.049C162.945 103.215 163.094 103.287 163.392 103.313C163.499 103.322 163.537 103.322 163.637 103.313C163.797 103.299 163.96 103.274 164.06 103.248L164.142 103.227L164.18 103.136C164.274 102.913 164.322 102.787 164.316 102.78C164.312 102.776 164.291 102.779 164.267 102.789C164.206 102.812 164.072 102.841 163.948 102.859C163.829 102.876 163.797 102.872 163.738 102.836C163.685 102.803 163.665 102.721 163.685 102.617C163.705 102.509 163.723 102.453 163.821 102.211C164 101.765 164.189 101.298 164.192 101.289C164.194 101.283 164.284 101.279 164.495 101.275L164.794 101.269L164.81 101.228C164.851 101.125 164.938 100.895 164.938 100.891C164.938 100.888 164.808 100.883 164.649 100.879L164.36 100.873L164.365 100.857C164.373 100.832 164.476 100.549 164.503 100.479C164.516 100.445 164.527 100.414 164.527 100.409C164.527 100.399 164.518 100.4 164.416 100.417ZM166.436 100.868C166.066 100.898 165.745 100.991 165.469 101.148C165.114 101.351 164.862 101.626 164.727 101.957C164.67 102.097 164.64 102.22 164.626 102.375C164.613 102.512 164.625 102.623 164.667 102.753C164.699 102.855 164.719 102.897 164.776 102.982C164.917 103.194 165.186 103.359 165.496 103.424C165.617 103.449 165.683 103.458 165.819 103.468C165.95 103.478 166.163 103.465 166.383 103.433C166.543 103.409 166.516 103.415 166.704 103.369L166.854 103.333L166.979 103.079C167.048 102.94 167.102 102.824 167.1 102.822C167.098 102.819 167.068 102.829 167.034 102.842C166.877 102.904 166.595 102.959 166.332 102.979C165.96 103.006 165.701 102.897 165.593 102.666C165.581 102.64 165.563 102.58 165.553 102.532C165.536 102.447 165.536 102.444 165.55 102.366C165.558 102.323 165.565 102.283 165.567 102.278C165.57 102.271 165.817 102.267 166.543 102.263L167.514 102.257L167.537 102.197C167.576 102.096 167.608 101.949 167.621 101.811C167.632 101.696 167.632 101.674 167.621 101.593C167.607 101.493 167.566 101.361 167.529 101.296C167.424 101.113 167.23 100.976 166.985 100.912C166.837 100.874 166.599 100.855 166.436 100.868ZM161.108 100.88C160.985 100.886 160.782 100.9 160.669 100.912C160.547 100.924 160.257 100.967 160.21 100.979C160.179 100.987 160.186 100.97 160.075 101.263C159.982 101.505 159.975 101.527 159.978 101.533C159.98 101.536 159.99 101.536 159.999 101.531C160.033 101.517 160.24 101.469 160.369 101.445C160.813 101.364 161.33 101.346 161.558 101.402C161.64 101.423 161.728 101.474 161.754 101.517C161.782 101.564 161.792 101.623 161.78 101.68C161.774 101.708 161.767 101.732 161.764 101.736C161.757 101.743 161.668 101.742 161.424 101.73C161.078 101.714 160.612 101.744 160.317 101.801C159.986 101.865 159.736 101.981 159.573 102.145C159.433 102.286 159.361 102.437 159.329 102.653C159.318 102.731 159.318 102.745 159.329 102.815C159.367 103.052 159.507 103.216 159.752 103.311C159.864 103.354 159.988 103.38 160.157 103.393C160.281 103.403 160.321 103.403 160.487 103.393C160.715 103.379 160.782 103.372 160.989 103.341C161.276 103.297 161.296 103.295 161.445 103.286C161.668 103.272 161.934 103.291 162.087 103.331C162.152 103.348 162.155 103.345 162.142 103.285C162.117 103.175 162.131 103.03 162.183 102.863C162.211 102.771 162.23 102.721 162.385 102.318C162.489 102.046 162.504 102.006 162.566 101.836C162.635 101.646 162.643 101.519 162.597 101.377C162.576 101.315 162.518 101.222 162.471 101.176C162.391 101.099 162.234 101.014 162.096 100.972C161.943 100.927 161.878 100.914 161.699 100.895C161.592 100.884 161.231 100.875 161.108 100.88ZM152.891 100.907C152.569 100.932 152.302 101.005 152.01 101.148C151.634 101.332 151.332 101.623 151.178 101.951C151.078 102.162 151.023 102.424 151.042 102.599C151.07 102.863 151.179 103.051 151.385 103.186C151.474 103.245 151.515 103.265 151.615 103.303C151.867 103.397 152.192 103.431 152.531 103.396C153.05 103.343 153.523 103.129 153.848 102.798C154.106 102.534 154.286 102.179 154.322 101.861C154.347 101.643 154.275 101.433 154.119 101.266C153.951 101.086 153.627 100.949 153.29 100.916C153.166 100.903 152.99 100.9 152.891 100.907ZM157.809 100.908C157.096 100.953 156.433 101.383 156.123 101.999C156.043 102.159 155.993 102.32 155.966 102.505C155.953 102.596 155.952 102.613 155.963 102.702C155.99 102.945 156.111 103.14 156.304 103.254C156.497 103.369 156.822 103.413 157.175 103.373C157.417 103.345 157.692 103.252 157.892 103.131C157.923 103.112 157.952 103.097 157.957 103.097C157.961 103.097 157.953 103.126 157.937 103.162C157.833 103.407 157.618 103.601 157.326 103.714C157.244 103.746 157.08 103.789 156.967 103.808C156.771 103.841 156.444 103.846 156.199 103.82C156.096 103.808 155.94 103.772 155.895 103.749C155.882 103.742 155.867 103.737 155.861 103.737C155.855 103.737 155.809 103.843 155.749 103.996C155.692 104.138 155.646 104.256 155.646 104.259C155.645 104.267 155.708 104.282 155.825 104.302C156.251 104.372 156.645 104.375 157.061 104.309C157.689 104.209 158.175 103.936 158.469 103.516C158.559 103.388 158.65 103.214 158.706 103.065C158.724 103.015 158.772 102.889 158.811 102.784C158.851 102.68 158.896 102.563 158.91 102.524C158.925 102.484 158.951 102.415 158.969 102.369C159 102.29 159.087 102.062 159.152 101.891C159.168 101.848 159.198 101.769 159.218 101.717C159.238 101.665 159.269 101.585 159.286 101.539C159.302 101.494 159.333 101.414 159.353 101.362C159.373 101.309 159.402 101.235 159.416 101.196C159.431 101.156 159.456 101.091 159.471 101.05C159.487 101.009 159.499 100.973 159.499 100.968C159.499 100.964 159.49 100.962 159.477 100.965C159.465 100.968 159.414 100.979 159.363 100.99C159.142 101.037 158.98 101.034 158.681 100.974C158.355 100.909 158.097 100.889 157.809 100.908ZM166.602 101.311C166.697 101.329 166.774 101.38 166.81 101.45C166.847 101.522 166.848 101.642 166.813 101.781L166.799 101.836L166.524 101.843C166.367 101.847 166.13 101.847 165.969 101.843L165.689 101.836L165.736 101.741C165.819 101.572 165.928 101.46 166.088 101.381C166.241 101.306 166.432 101.28 166.602 101.311ZM153.081 101.318C153.308 101.346 153.413 101.443 153.448 101.66C153.459 101.727 153.459 101.74 153.444 101.833C153.412 102.044 153.353 102.229 153.257 102.419C153.11 102.713 152.869 102.915 152.6 102.972C152.468 103 152.291 102.989 152.176 102.946C152.088 102.913 152.013 102.848 151.972 102.768C151.928 102.683 151.917 102.476 151.949 102.328C152.024 101.981 152.236 101.65 152.496 101.477C152.565 101.43 152.606 101.409 152.681 101.379C152.764 101.347 152.811 101.335 152.91 101.322C153.005 101.309 153.004 101.309 153.081 101.318ZM158.071 101.37C158.139 101.378 158.206 101.39 158.242 101.402C158.304 101.423 158.4 101.475 158.429 101.504L158.446 101.521L158.42 101.615C158.361 101.83 158.3 101.989 158.21 102.167C158.013 102.558 157.752 102.808 157.448 102.894C157.211 102.962 156.999 102.925 156.909 102.8C156.856 102.728 156.84 102.666 156.84 102.535C156.84 102.445 156.843 102.415 156.862 102.338C156.887 102.239 156.932 102.112 156.971 102.035C157.028 101.922 157.16 101.744 157.23 101.686C157.251 101.668 157.287 101.638 157.311 101.618C157.413 101.529 157.582 101.438 157.711 101.401C157.767 101.385 157.886 101.363 157.948 101.358C157.954 101.358 158.009 101.363 158.071 101.37ZM161.438 102.184C161.509 102.187 161.567 102.194 161.573 102.199C161.582 102.206 161.575 102.231 161.529 102.35C161.442 102.577 161.439 102.583 161.412 102.657L161.385 102.728L161.33 102.753C161.134 102.844 160.755 102.908 160.547 102.887C160.431 102.875 160.386 102.864 160.328 102.835C160.215 102.779 160.171 102.684 160.199 102.559C160.217 102.48 160.242 102.433 160.293 102.382C160.413 102.265 160.631 102.209 161.056 102.187C161.146 102.183 161.226 102.178 161.234 102.176C161.243 102.175 161.264 102.175 161.282 102.176C161.299 102.178 161.369 102.182 161.438 102.184ZM152.662 104.487C152.662 104.492 152.628 104.581 152.586 104.687C152.544 104.793 152.499 104.908 152.486 104.942C152.473 104.977 152.453 105.025 152.443 105.049L152.424 105.091L152.459 105.143C152.644 105.416 152.82 105.634 153.079 105.913C153.867 106.758 154.906 107.399 156.021 107.728C156.655 107.915 157.242 108 157.902 108C158.628 108 159.288 107.893 159.984 107.664C161.183 107.269 162.265 106.514 163.061 105.519C163.124 105.441 163.204 105.336 163.239 105.286C163.275 105.236 163.322 105.17 163.343 105.14C163.365 105.11 163.383 105.081 163.383 105.077C163.383 105.072 163.335 104.952 163.278 104.808C163.22 104.665 163.167 104.532 163.16 104.514C163.153 104.495 163.145 104.48 163.142 104.48C163.135 104.48 163.139 104.476 163.009 104.618C162.662 104.998 162.194 105.411 161.779 105.706C161.463 105.93 161.193 106.092 160.856 106.26C160.638 106.369 160.489 106.436 160.306 106.508C160.234 106.537 160.166 106.564 160.155 106.568C160.039 106.618 159.702 106.719 159.444 106.783C158.955 106.903 158.553 106.954 157.938 106.971C157.675 106.979 157.163 106.936 156.831 106.879C156.154 106.762 155.583 106.574 154.962 106.265C154.295 105.934 153.761 105.552 153.138 104.963C153.025 104.856 152.781 104.601 152.712 104.518C152.683 104.483 152.662 104.47 152.662 104.487Z",
    fill: "#97312E"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 163,
    y: 187.692,
    width: 78.6871,
    height: 58.7217,
    fill: "url(#pattern2)"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 259.667,
    y: 197.448,
    width: 97.8553,
    height: 38.1348,
    fill: "url(#pattern3)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.915 55.0637C167.889 55.0979 167.683 55.2381 167.456 55.3752C166.418 56.0032 164.736 56.4212 162.95 56.4951C160.68 56.5891 158.577 56.1229 157.116 55.2024C156.928 55.0843 156.966 55.1325 157.25 55.3757C157.892 55.9236 159.403 56.5967 160.515 56.8304C161.806 57.1015 163.988 57.04 165.022 56.7034C166.185 56.3252 167.704 55.504 167.957 55.1175C168.035 54.9984 167.999 54.9524 167.915 55.0637Z",
    fill: "url(#paint221_radial_4903_18626)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M151.5 34C150 34.5 147 37 147 37C147 37 149 34 151 33C153 32 156 32 156 32C156 32 157.5 32 157.5 33C157.5 34 156.5 34 156.5 34C156.5 34 153 33.5 151.5 34Z",
    fill: "#311739"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M173.571 34C174.714 34.5 177 37 177 37C177 37 175.476 34 173.952 33C172.429 32 170.143 32 170.143 32C170.143 32 169 32 169 33C169 34 169.762 34 169.762 34C169.762 34 172.429 33.5 173.571 34Z",
    fill: "#311739"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_4903_18626",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 162,
    y: 51,
    width: 4,
    height: 1
  }, _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M166 51H162L164.4 51.5L166 51Z",
    fill: "url(#paint222_linear_4903_18626)"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_4903_18626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162 51V50L161.796 51.979L162 51ZM166 51L166.298 51.9545L166 50V51ZM164.4 51.5L164.196 52.479L164.45 52.532L164.698 52.4545L164.4 51.5ZM162 52H166V50H162V52ZM165.702 50.0455L164.102 50.5455L164.698 52.4545L166.298 51.9545L165.702 50.0455ZM164.604 50.521L162.204 50.021L161.796 51.979L164.196 52.479L164.604 50.521Z",
    fill: "url(#paint223_linear_4903_18626)"
  }))), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M151.665 37.4712C150.208 37.719 147.128 39.4211 147.128 39.4211C147.128 39.4211 149.329 37.214 151.308 36.6155C153.288 36.017 155.158 36.2227 156.093 36.3256C157.027 36.4285 157.403 37.4712 157.403 37.4712C157.403 37.4712 157.337 37.3333 156.403 37.2304C155.468 37.1275 153.123 37.2234 151.665 37.4712Z",
    fill: "#311739"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M172.91 37.2229C174.128 37.414 176.773 38.9944 176.773 38.9944C176.773 38.9944 175.416 37.1474 173.746 36.6264C172.075 36.1054 169.951 36.1114 169.185 36.2503C168.419 36.3893 168.17 37.4451 168.17 37.4451C168.17 37.4451 168.215 37.3048 168.982 37.1659C169.748 37.0269 171.691 37.0319 172.91 37.2229Z",
    fill: "#311739"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M166 51H162L164.4 51.5L166 51Z",
    fill: "url(#paint224_linear_4903_18626)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4903_18626",
    transform: "translate(0 -0.00249998) scale(0.00333333 0.00446667)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_4903_18626",
    transform: "translate(-3.37585e-09 -0.325581) scale(0.00534759 0.0136799)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4903_18626",
    x: 150,
    y: 40.3437,
    width: 5.54047,
    height: 3.20178,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_4903_18626"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_4903_18626",
    x: 169.868,
    y: 40.3435,
    width: 4.92926,
    height: 3.20178,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_4903_18626"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_4903_18626",
    x: 157,
    y: 46,
    width: 13,
    height: 10,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_4903_18626"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4903_18626",
    transform: "translate(0 -0.00249998) scale(0.00333333 0.00446667)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern3",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_4903_18626",
    transform: "translate(-3.37585e-09 -0.325581) scale(0.00534759 0.0136799)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4903_18626",
    x1: 159,
    y1: 520.3,
    x2: 159,
    y2: 505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA9F80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504186,
    stopColor: "#F8C2A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4903_18626",
    x1: 137.322,
    y1: 568,
    x2: 189.322,
    y2: 572.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#573361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#573361",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4903_18626",
    x1: 155.171,
    y1: 565.267,
    x2: 155.171,
    y2: 515.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBA173"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCAAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4903_18626",
    x1: 155.171,
    y1: 565.267,
    x2: 155.171,
    y2: 515.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBA173"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCAAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4903_18626",
    x1: 137.259,
    y1: 505.58,
    x2: 179.759,
    y2: 499.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.307901,
    stopColor: "#C4C5E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAD8F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4903_18626",
    x1: 138.881,
    y1: 478.71,
    x2: 185.878,
    y2: 437.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D0ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDAF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4903_18626",
    x1: 166,
    y1: 490.5,
    x2: 166,
    y2: 409.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9996CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B1CE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4903_18626",
    x1: 131,
    y1: 481.5,
    x2: 131.432,
    y2: 433.245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D0ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0ED",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4903_18626",
    x1: 189.35,
    y1: 467.263,
    x2: 203.341,
    y2: 424.736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D0ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0ED",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4903_18626",
    x1: 206,
    y1: 511.5,
    x2: 261.5,
    y2: 450,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#100D16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#452D57"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4903_18626",
    x1: 210,
    y1: 511.5,
    x2: 265.5,
    y2: 450,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#341A3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#452D57"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4903_18626",
    x1: 247.5,
    y1: 523,
    x2: 279.5,
    y2: 455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#623F6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#623F6C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4903_18626",
    x1: 26.5,
    y1: 6.5,
    x2: 2.5,
    y2: 1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#100D16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32193A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4903_18626",
    x1: 246.5,
    y1: 470.5,
    x2: 252.75,
    y2: 441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61406D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976873,
    stopColor: "#251629"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4903_18626",
    x1: 235,
    y1: 466.5,
    x2: 238.5,
    y2: 440,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#110D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B203D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4903_18626",
    x1: 379,
    y1: 487.5,
    x2: 460,
    y2: 296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#612732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652564,
    stopColor: "#AF3934"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_4903_18626",
    x1: 483,
    y1: 486.5,
    x2: 533.5,
    y2: 299.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C44B46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#B94541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_4903_18626",
    x1: 514.5,
    y1: 507.5,
    x2: 527.5,
    y2: 499.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#573361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#573361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_4903_18626",
    x1: 511.5,
    y1: 474,
    x2: 540,
    y2: 442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#782F32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B3735"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_4903_18626",
    x1: 494.955,
    y1: 500.137,
    x2: 500.864,
    y2: 496.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#573361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#573361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_4903_18626",
    x1: 511.5,
    y1: 423.5,
    x2: 540,
    y2: 391.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#782F32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#853330"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_4903_18626",
    x1: 523,
    y1: 342,
    x2: 520,
    y2: 310.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE5D59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE5D59",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_4903_18626",
    x1: 511.5,
    y1: 373.5,
    x2: 540,
    y2: 341.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#782F32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#853330"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_4903_18626",
    x1: 493,
    y1: 536.497,
    x2: 518,
    y2: 503.497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7BF62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7BF62",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_4903_18626",
    x1: 499.5,
    y1: 480,
    x2: 499.5,
    y2: 443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D99D9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1B4A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_4903_18626",
    x1: 499.5,
    y1: 478,
    x2: 499.5,
    y2: 445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D94A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#953B37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_4903_18626",
    x1: 501.5,
    y1: 478,
    x2: 501.5,
    y2: 445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_4903_18626",
    x1: 501.5,
    y1: 478,
    x2: 501.5,
    y2: 445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_4903_18626",
    x1: 501.5,
    y1: 478,
    x2: 501.5,
    y2: 445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_4903_18626",
    x1: 510.5,
    y1: 480,
    x2: 510.5,
    y2: 443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D99D9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1B4A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_4903_18626",
    x1: 510.5,
    y1: 478,
    x2: 510.5,
    y2: 445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D94A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#953B37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_4903_18626",
    x1: 512.5,
    y1: 478,
    x2: 512.5,
    y2: 445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_4903_18626",
    x1: 512.5,
    y1: 478,
    x2: 512.5,
    y2: 445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_4903_18626",
    x1: 512.5,
    y1: 478,
    x2: 512.5,
    y2: 445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_4903_18626",
    x1: 485.5,
    y1: 429,
    x2: 485.5,
    y2: 392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D99D9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1B4A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_4903_18626",
    x1: 485.5,
    y1: 427,
    x2: 485.5,
    y2: 394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D94A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#953B37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_4903_18626",
    x1: 487.5,
    y1: 427,
    x2: 487.5,
    y2: 394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_4903_18626",
    x1: 487.5,
    y1: 427,
    x2: 487.5,
    y2: 394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_4903_18626",
    x1: 487.5,
    y1: 427,
    x2: 487.5,
    y2: 394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_4903_18626",
    x1: 496.5,
    y1: 429,
    x2: 496.5,
    y2: 392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D99D9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1B4A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_4903_18626",
    x1: 496.5,
    y1: 427,
    x2: 496.5,
    y2: 394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D94A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#953B37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_4903_18626",
    x1: 498.5,
    y1: 427,
    x2: 498.5,
    y2: 394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_4903_18626",
    x1: 498.5,
    y1: 427,
    x2: 498.5,
    y2: 394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_4903_18626",
    x1: 498.5,
    y1: 427,
    x2: 498.5,
    y2: 394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_4903_18626",
    x1: 507.5,
    y1: 429,
    x2: 507.5,
    y2: 392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D99D9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1B4A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_4903_18626",
    x1: 507.5,
    y1: 427,
    x2: 507.5,
    y2: 394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D94A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#953B37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_4903_18626",
    x1: 509.5,
    y1: 427,
    x2: 509.5,
    y2: 394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_4903_18626",
    x1: 509.5,
    y1: 427,
    x2: 509.5,
    y2: 394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_4903_18626",
    x1: 509.5,
    y1: 427,
    x2: 509.5,
    y2: 394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_4903_18626",
    x1: 550,
    y1: 397.5,
    x2: 513,
    y2: 397.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D99D9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1B4A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_4903_18626",
    x1: 548,
    y1: 397.5,
    x2: 515,
    y2: 397.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D94A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#953B37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_4903_18626",
    x1: 548,
    y1: 399.5,
    x2: 515,
    y2: 399.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_4903_18626",
    x1: 548,
    y1: 399.5,
    x2: 515,
    y2: 399.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_4903_18626",
    x1: 548,
    y1: 399.5,
    x2: 515,
    y2: 399.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_4903_18626",
    x1: 517,
    y1: 347.5,
    x2: 480,
    y2: 347.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D99D9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1B4A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_4903_18626",
    x1: 515,
    y1: 347.5,
    x2: 482,
    y2: 347.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D94A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#953B37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_4903_18626",
    x1: 515,
    y1: 349.5,
    x2: 482,
    y2: 349.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_4903_18626",
    x1: 515,
    y1: 349.5,
    x2: 482,
    y2: 349.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_4903_18626",
    x1: 515,
    y1: 349.5,
    x2: 482,
    y2: 349.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_4903_18626",
    x1: 523.498,
    y1: 378.882,
    x2: 524.296,
    y2: 341.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D99D9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1B4A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_4903_18626",
    x1: 523.541,
    y1: 376.882,
    x2: 524.252,
    y2: 343.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D94A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#953B37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_4903_18626",
    x1: 521.542,
    y1: 376.839,
    x2: 522.253,
    y2: 343.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_4903_18626",
    x1: 521.542,
    y1: 376.839,
    x2: 522.253,
    y2: 343.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_4903_18626",
    x1: 521.542,
    y1: 376.839,
    x2: 522.253,
    y2: 343.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_4903_18626",
    x1: 535.498,
    y1: 378.882,
    x2: 536.296,
    y2: 341.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D99D9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1B4A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_4903_18626",
    x1: 535.541,
    y1: 376.882,
    x2: 536.252,
    y2: 343.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D94A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#953B37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_4903_18626",
    x1: 533.542,
    y1: 376.839,
    x2: 534.253,
    y2: 343.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_4903_18626",
    x1: 533.542,
    y1: 376.839,
    x2: 534.253,
    y2: 343.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_4903_18626",
    x1: 533.542,
    y1: 376.839,
    x2: 534.253,
    y2: 343.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_4903_18626",
    x1: 542.763,
    y1: 376.25,
    x2: 561.263,
    y2: 344.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D99D9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1B4A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_4903_18626",
    x1: 543.763,
    y1: 374.518,
    x2: 560.263,
    y2: 345.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D94A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#953B37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_4903_18626",
    x1: 542.031,
    y1: 373.518,
    x2: 558.531,
    y2: 344.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_4903_18626",
    x1: 542.031,
    y1: 373.518,
    x2: 558.531,
    y2: 344.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_4903_18626",
    x1: 542.031,
    y1: 373.518,
    x2: 558.531,
    y2: 344.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_4903_18626",
    x1: 545.211,
    y1: 473.257,
    x2: 520.03,
    y2: 446.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D99D9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1B4A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_4903_18626",
    x1: 543.85,
    y1: 471.792,
    x2: 521.391,
    y2: 447.614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D94A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#953B37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_4903_18626",
    x1: 545.315,
    y1: 470.43,
    x2: 522.856,
    y2: 446.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_4903_18626",
    x1: 545.315,
    y1: 470.43,
    x2: 522.856,
    y2: 446.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_4903_18626",
    x1: 545.315,
    y1: 470.43,
    x2: 522.856,
    y2: 446.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_4903_18626",
    x1: 554.5,
    y1: 479,
    x2: 554.5,
    y2: 442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D99D9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1B4A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_4903_18626",
    x1: 554.5,
    y1: 477,
    x2: 554.5,
    y2: 444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D94A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#953B37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_4903_18626",
    x1: 556.5,
    y1: 477,
    x2: 556.5,
    y2: 444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_4903_18626",
    x1: 556.5,
    y1: 477,
    x2: 556.5,
    y2: 444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_4903_18626",
    x1: 556.5,
    y1: 477,
    x2: 556.5,
    y2: 444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_4903_18626",
    x1: 407,
    y1: 440.5,
    x2: 408,
    y2: 446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5A3CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_4903_18626",
    x1: 399.5,
    y1: 436.5,
    x2: 401.5,
    y2: 443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0434761,
    stopColor: "#A5A3CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_4903_18626",
    x1: 405.012,
    y1: 437.5,
    x2: 406.862,
    y2: 444.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0434761,
    stopColor: "#A5A3CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_4903_18626",
    x1: 402.5,
    y1: 444.5,
    x2: 432.5,
    y2: 443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5A3CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5A3CF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_4903_18626",
    x1: 405.146,
    y1: 436.5,
    x2: 406.896,
    y2: 443.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0434761,
    stopColor: "#A5A3CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_4903_18626",
    x1: 393,
    y1: 441.5,
    x2: 436.5,
    y2: 440.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5A3CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5A3CF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_4903_18626",
    x1: 21,
    y1: -0.000148654,
    x2: 248.018,
    y2: 4.58356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B3168"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#694B78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_4903_18626",
    x1: 339,
    y1: 19,
    x2: 199,
    y2: -0.0000429342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6F5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_4903_18626",
    x1: 91,
    y1: 300,
    x2: 134.258,
    y2: 300.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32193A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#694B78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_4903_18626",
    x1: 134,
    y1: 413.5,
    x2: 370.5,
    y2: 314.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_4903_18626",
    x1: 94,
    y1: 447,
    x2: 146.189,
    y2: 447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7067AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B7F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_4903_18626",
    x1: 96.821,
    y1: 447,
    x2: 143.368,
    y2: 447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E2247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#664876"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_4903_18626",
    x1: 96.8108,
    y1: 449.546,
    x2: 143.189,
    y2: 449.546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9587CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2B7EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_4903_18626",
    x1: 96.8108,
    y1: 449.546,
    x2: 143.189,
    y2: 449.546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9587CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2B7EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_4903_18626",
    x1: 96.8108,
    y1: 449.546,
    x2: 143.189,
    y2: 449.546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9587CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2B7EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_4903_18626",
    x1: 102,
    y1: 422,
    x2: 409,
    y2: 422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAB2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9CDEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_4903_18626",
    x1: 102,
    y1: 429,
    x2: 409,
    y2: 429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB413D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB4944"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_4903_18626",
    x1: 77.6307,
    y1: 429,
    x2: 79.268,
    y2: 429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB413D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB4944"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_4903_18626",
    x1: 449.131,
    y1: 429,
    x2: 450.768,
    y2: 429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB4742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB4944"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_4903_18626",
    x1: 10.5,
    y1: 435,
    x2: 72.5,
    y2: 429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#672832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D3633"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_4903_18626",
    x1: 33,
    y1: 429,
    x2: 67,
    y2: 317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9DCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9CDEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_4903_18626",
    x1: 338.5,
    y1: 447,
    x2: 361,
    y2: 439.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#381E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#563560"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_4903_18626",
    x1: 81.7266,
    y1: 453.642,
    x2: 101.727,
    y2: 451.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#341A3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#573661"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_4903_18626",
    x1: 159,
    y1: 61.3924,
    x2: 159,
    y2: 76.6924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA9F80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504186,
    stopColor: "#F8C2A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_4903_18626",
    x1: 137.05,
    y1: 13.7766,
    x2: 188.179,
    y2: 9.35554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#573361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#573361",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_4903_18626",
    x1: 155.171,
    y1: 16.4254,
    x2: 155.171,
    y2: 66.0924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBA173"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCAAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_4903_18626",
    x1: 155.171,
    y1: 16.4254,
    x2: 155.171,
    y2: 66.0924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBA173"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCAAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_4903_18626",
    x1: 137.259,
    y1: 76.1129,
    x2: 179.759,
    y2: 82.6129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.307901,
    stopColor: "#C4C5E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAD8F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_4903_18626",
    x1: 138.881,
    y1: 102.982,
    x2: 185.878,
    y2: 143.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D0ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDAF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_4903_18626",
    x1: 166,
    y1: 91.1924,
    x2: 166,
    y2: 172.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9996CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B1CE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_4903_18626",
    x1: 131,
    y1: 100.192,
    x2: 131.432,
    y2: 148.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D0ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0ED",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_4903_18626",
    x1: 189.35,
    y1: 114.429,
    x2: 203.341,
    y2: 156.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D0ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D0ED",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_4903_18626",
    x1: 206,
    y1: 70.1924,
    x2: 261.5,
    y2: 131.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#100D16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#452D57"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_4903_18626",
    x1: 210,
    y1: 70.1924,
    x2: 265.5,
    y2: 131.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#341A3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#452D57"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_4903_18626",
    x1: 247.5,
    y1: 58.6924,
    x2: 279.5,
    y2: 126.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#623F6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#623F6C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_4903_18626",
    x1: 243.5,
    y1: 143.692,
    x2: 219.5,
    y2: 138.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#100D16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32193A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_4903_18626",
    x1: 246.5,
    y1: 111.192,
    x2: 252.75,
    y2: 140.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61406D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976873,
    stopColor: "#251629"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_4903_18626",
    x1: 235,
    y1: 115.192,
    x2: 238.5,
    y2: 141.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#110D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B203D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_4903_18626",
    x1: 379,
    y1: 94.1924,
    x2: 460,
    y2: 285.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#612732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652564,
    stopColor: "#AF3934"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_4903_18626",
    x1: 483,
    y1: 95.1924,
    x2: 533.5,
    y2: 282.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C44B46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#B94541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_4903_18626",
    x1: 514.5,
    y1: 74.1924,
    x2: 527.5,
    y2: 82.1924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#573361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#573361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_4903_18626",
    x1: 511.5,
    y1: 107.692,
    x2: 540,
    y2: 139.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#782F32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B3735"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_4903_18626",
    x1: 494.955,
    y1: 81.556,
    x2: 500.864,
    y2: 85.1924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#573361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#573361",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_4903_18626",
    x1: 511.5,
    y1: 158.192,
    x2: 540,
    y2: 190.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#782F32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#853330"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_4903_18626",
    x1: 523,
    y1: 239.692,
    x2: 520,
    y2: 271.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE5D59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE5D59",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_4903_18626",
    x1: 511.5,
    y1: 208.192,
    x2: 540,
    y2: 240.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#782F32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#853330"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_4903_18626",
    x1: 493,
    y1: 45.1958,
    x2: 518,
    y2: 78.1958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7BF62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7BF62",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_4903_18626",
    x1: 499.5,
    y1: 101.692,
    x2: 499.5,
    y2: 138.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D99D9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1B4A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_4903_18626",
    x1: 499.5,
    y1: 103.692,
    x2: 499.5,
    y2: 136.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D94A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#953B37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_4903_18626",
    x1: 501.5,
    y1: 103.692,
    x2: 501.5,
    y2: 136.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_4903_18626",
    x1: 501.5,
    y1: 103.692,
    x2: 501.5,
    y2: 136.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_4903_18626",
    x1: 501.5,
    y1: 103.692,
    x2: 501.5,
    y2: 136.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_4903_18626",
    x1: 510.5,
    y1: 101.692,
    x2: 510.5,
    y2: 138.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D99D9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1B4A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_4903_18626",
    x1: 510.5,
    y1: 103.692,
    x2: 510.5,
    y2: 136.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D94A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#953B37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_4903_18626",
    x1: 512.5,
    y1: 103.692,
    x2: 512.5,
    y2: 136.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_4903_18626",
    x1: 512.5,
    y1: 103.692,
    x2: 512.5,
    y2: 136.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_4903_18626",
    x1: 512.5,
    y1: 103.692,
    x2: 512.5,
    y2: 136.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_4903_18626",
    x1: 485.5,
    y1: 152.692,
    x2: 485.5,
    y2: 189.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D99D9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1B4A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_4903_18626",
    x1: 485.5,
    y1: 154.692,
    x2: 485.5,
    y2: 187.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D94A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#953B37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_4903_18626",
    x1: 487.5,
    y1: 154.692,
    x2: 487.5,
    y2: 187.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_4903_18626",
    x1: 487.5,
    y1: 154.692,
    x2: 487.5,
    y2: 187.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_4903_18626",
    x1: 487.5,
    y1: 154.692,
    x2: 487.5,
    y2: 187.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_4903_18626",
    x1: 496.5,
    y1: 152.692,
    x2: 496.5,
    y2: 189.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D99D9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1B4A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_4903_18626",
    x1: 496.5,
    y1: 154.692,
    x2: 496.5,
    y2: 187.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D94A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#953B37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_4903_18626",
    x1: 498.5,
    y1: 154.692,
    x2: 498.5,
    y2: 187.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_4903_18626",
    x1: 498.5,
    y1: 154.692,
    x2: 498.5,
    y2: 187.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_4903_18626",
    x1: 498.5,
    y1: 154.692,
    x2: 498.5,
    y2: 187.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_4903_18626",
    x1: 507.5,
    y1: 152.692,
    x2: 507.5,
    y2: 189.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D99D9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1B4A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_4903_18626",
    x1: 507.5,
    y1: 154.692,
    x2: 507.5,
    y2: 187.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D94A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#953B37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_4903_18626",
    x1: 509.5,
    y1: 154.692,
    x2: 509.5,
    y2: 187.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_4903_18626",
    x1: 509.5,
    y1: 154.692,
    x2: 509.5,
    y2: 187.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_4903_18626",
    x1: 509.5,
    y1: 154.692,
    x2: 509.5,
    y2: 187.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_4903_18626",
    x1: 550,
    y1: 184.192,
    x2: 513,
    y2: 184.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D99D9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1B4A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_4903_18626",
    x1: 548,
    y1: 184.192,
    x2: 515,
    y2: 184.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D94A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#953B37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_4903_18626",
    x1: 548,
    y1: 182.192,
    x2: 515,
    y2: 182.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_4903_18626",
    x1: 548,
    y1: 182.192,
    x2: 515,
    y2: 182.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_4903_18626",
    x1: 548,
    y1: 182.192,
    x2: 515,
    y2: 182.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_4903_18626",
    x1: 517,
    y1: 234.192,
    x2: 480,
    y2: 234.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D99D9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1B4A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_4903_18626",
    x1: 515,
    y1: 234.192,
    x2: 482,
    y2: 234.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D94A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#953B37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_4903_18626",
    x1: 515,
    y1: 232.192,
    x2: 482,
    y2: 232.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_4903_18626",
    x1: 515,
    y1: 232.192,
    x2: 482,
    y2: 232.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_4903_18626",
    x1: 515,
    y1: 232.192,
    x2: 482,
    y2: 232.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_4903_18626",
    x1: 523.498,
    y1: 202.811,
    x2: 524.296,
    y2: 239.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D99D9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1B4A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_4903_18626",
    x1: 523.541,
    y1: 204.81,
    x2: 524.252,
    y2: 237.803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D94A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#953B37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_4903_18626",
    x1: 521.542,
    y1: 204.854,
    x2: 522.253,
    y2: 237.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_4903_18626",
    x1: 521.542,
    y1: 204.854,
    x2: 522.253,
    y2: 237.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_4903_18626",
    x1: 521.542,
    y1: 204.854,
    x2: 522.253,
    y2: 237.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_4903_18626",
    x1: 535.498,
    y1: 202.811,
    x2: 536.296,
    y2: 239.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D99D9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1B4A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_4903_18626",
    x1: 535.541,
    y1: 204.81,
    x2: 536.252,
    y2: 237.803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D94A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#953B37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_4903_18626",
    x1: 533.542,
    y1: 204.854,
    x2: 534.253,
    y2: 237.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_4903_18626",
    x1: 533.542,
    y1: 204.854,
    x2: 534.253,
    y2: 237.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_4903_18626",
    x1: 533.542,
    y1: 204.854,
    x2: 534.253,
    y2: 237.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_4903_18626",
    x1: 542.763,
    y1: 205.442,
    x2: 561.263,
    y2: 237.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D99D9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1B4A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_4903_18626",
    x1: 543.763,
    y1: 207.174,
    x2: 560.263,
    y2: 235.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D94A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#953B37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_4903_18626",
    x1: 542.031,
    y1: 208.174,
    x2: 558.531,
    y2: 236.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_4903_18626",
    x1: 542.031,
    y1: 208.174,
    x2: 558.531,
    y2: 236.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_4903_18626",
    x1: 542.031,
    y1: 208.174,
    x2: 558.531,
    y2: 236.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_4903_18626",
    x1: 545.211,
    y1: 108.436,
    x2: 520.03,
    y2: 135.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D99D9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1B4A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_4903_18626",
    x1: 543.85,
    y1: 109.901,
    x2: 521.391,
    y2: 134.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D94A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#953B37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_4903_18626",
    x1: 545.315,
    y1: 111.262,
    x2: 522.856,
    y2: 135.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_4903_18626",
    x1: 545.315,
    y1: 111.262,
    x2: 522.856,
    y2: 135.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_4903_18626",
    x1: 545.315,
    y1: 111.262,
    x2: 522.856,
    y2: 135.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_4903_18626",
    x1: 554.5,
    y1: 102.692,
    x2: 554.5,
    y2: 139.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D99D9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1B4A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_4903_18626",
    x1: 554.5,
    y1: 104.692,
    x2: 554.5,
    y2: 137.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D94A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#953B37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_4903_18626",
    x1: 556.5,
    y1: 104.692,
    x2: 556.5,
    y2: 137.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_4903_18626",
    x1: 556.5,
    y1: 104.692,
    x2: 556.5,
    y2: 137.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_4903_18626",
    x1: 556.5,
    y1: 104.692,
    x2: 556.5,
    y2: 137.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9BBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_4903_18626",
    x1: 407,
    y1: 141.192,
    x2: 408,
    y2: 135.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5A3CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_4903_18626",
    x1: 399.5,
    y1: 145.192,
    x2: 401.5,
    y2: 138.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0434761,
    stopColor: "#A5A3CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_4903_18626",
    x1: 405.012,
    y1: 144.192,
    x2: 406.862,
    y2: 137.595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0434761,
    stopColor: "#A5A3CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_4903_18626",
    x1: 402.5,
    y1: 137.192,
    x2: 432.5,
    y2: 138.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5A3CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5A3CF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_4903_18626",
    x1: 405.146,
    y1: 145.192,
    x2: 406.896,
    y2: 138.537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0434761,
    stopColor: "#A5A3CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_4903_18626",
    x1: 393,
    y1: 140.192,
    x2: 436.5,
    y2: 141.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5A3CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5A3CF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_4903_18626",
    x1: 108,
    y1: 279.692,
    x2: 335.018,
    y2: 284.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B3168"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#694B78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear_4903_18626",
    x1: 426,
    y1: 298.692,
    x2: 286,
    y2: 279.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6F5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear_4903_18626",
    x1: 4,
    y1: -0.000123878,
    x2: 47.2582,
    y2: 0.199516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32193A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#694B78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear_4903_18626",
    x1: 134,
    y1: 168.192,
    x2: 370.5,
    y2: 267.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear_4903_18626",
    x1: 94,
    y1: 134.692,
    x2: 146.189,
    y2: 134.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7067AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B7F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint202_linear_4903_18626",
    x1: 96.821,
    y1: 134.692,
    x2: 143.368,
    y2: 134.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E2247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#664876"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_4903_18626",
    x1: 96.8108,
    y1: 132.147,
    x2: 143.189,
    y2: 132.147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9587CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2B7EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear_4903_18626",
    x1: 96.8108,
    y1: 132.147,
    x2: 143.189,
    y2: 132.147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9587CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2B7EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint205_linear_4903_18626",
    x1: 96.8108,
    y1: 132.147,
    x2: 143.189,
    y2: 132.147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9587CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2B7EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_4903_18626",
    x1: 102,
    y1: 159.693,
    x2: 409,
    y2: 159.693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAB2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9CDEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear_4903_18626",
    x1: 102,
    y1: 152.692,
    x2: 409,
    y2: 152.693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB413D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB4944"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_4903_18626",
    x1: 77.6307,
    y1: 152.692,
    x2: 79.268,
    y2: 152.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB413D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB4944"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_4903_18626",
    x1: 449.131,
    y1: 152.692,
    x2: 450.768,
    y2: 152.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB4742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB4944"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint210_linear_4903_18626",
    x1: 10.5,
    y1: 146.692,
    x2: 72.5,
    y2: 152.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#672832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D3633"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint211_linear_4903_18626",
    x1: 33,
    y1: 152.692,
    x2: 67,
    y2: 264.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9DCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9CDEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_4903_18626",
    x1: 338.5,
    y1: 134.692,
    x2: 361,
    y2: 142.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#381E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#563560"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint213_linear_4903_18626",
    x1: 81.7266,
    y1: 128.051,
    x2: 101.727,
    y2: 130.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#341A3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#573661"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint214_linear_4903_18626",
    x1: 150.714,
    y1: 37.5173,
    x2: 152.041,
    y2: 40.8747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E7E7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint215_linear_4903_18626",
    x1: 153,
    y1: 36.8381,
    x2: 152.983,
    y2: 45.5826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53305D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint216_linear_4903_18626",
    x1: 174.034,
    y1: 37.5174,
    x2: 172.524,
    y2: 40.6781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E7E7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint217_linear_4903_18626",
    x1: 172.142,
    y1: 36.8384,
    x2: 172.163,
    y2: 45.5828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53305D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint218_linear_4903_18626",
    x1: 162,
    y1: 50.5,
    x2: 164.831,
    y2: 53.2177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#311739",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint219_linear_4903_18626",
    x1: 340,
    y1: 116.5,
    x2: 361,
    y2: 107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B91C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9C0DA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint220_linear_4903_18626",
    x1: 378,
    y1: 91,
    x2: 360,
    y2: 111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9C0DA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint221_radial_4903_18626",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(162.5 56.5002) rotate(175.276) scale(6.07063 27.6331)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#311739",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint222_linear_4903_18626",
    x1: 162,
    y1: 50.5,
    x2: 164.831,
    y2: 53.2177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#311739",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint223_linear_4903_18626",
    x1: 162,
    y1: 50.5,
    x2: 164.831,
    y2: 53.2177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#311739",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint224_linear_4903_18626",
    x1: 162,
    y1: 50.5,
    x2: 167,
    y2: 52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#311739",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_4903_18626",
    width: 300,
    height: 225,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_4903_18626",
    width: 187,
    height: 113,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeskImage2);
export default __webpack_public_path__ + "static/media/deskImage2.99faffbfcc1230c5e57682d794c2db90.svg";
export { ForwardRef as ReactComponent };